import { gql } from "@apollo/client";
import { client } from "./store/store";
import {
  fetchCurrentUserDataFailure,
  fetchCurrentUserDataRequest,
  fetchCurrentUserDataSuccess,
  fetchContributionPlanBundleFailure,
  fetchContributionPlanBundleRequest,
  fetchContributionPlanBundleSuccess,
  fetchDataFailure,
  fetchDataRequest,
  fetchDataSuccess,
  fetchDistrictLocationFailure,
  fetchDistrictLocationRequest,
  fetchDistrictLocationSuccess,
  fetchForgotDataFailure,
  fetchForgotDataRequest,
  fetchForgotDataSuccess,
  fetchLocationFailure,
  fetchLocationRequest,
  fetchLocationSuccess,
  fetchLoginDataFailure,
  fetchLoginDataRequest,
  fetchLoginDataSuccess,
  fetchRefreshTokenDataFailure,
  fetchRefreshTokenDataRequest,
  fetchRefreshTokenDataSuccess,
  fetchResetDataFailure,
  fetchResetDataRequest,
  fetchResetDataSuccess,
  fetchContributionIDPlanBundleSuccess,
  fetchContributionIDPlanBundleRequest,
  fetchContributionIDPlanBundleFailure,
  fetchContributionPlanByIdBundleFailure,
  fetchContributionPlanByIdBundleSuccess,
  fetchContributionPlanByIdBundleRequest,
  fetchInsureeByIdRequest,
  fetchInsureeByIdSuccess,
  fetchInsureeByIdFailure,
  fetchPolicyHolderByInsureeRequest,
  fetchPolicyHolderByInsureeSuccess,
  fetchPolicyHolderByInsureeFailure,
  fetchPolicyholderUserFailure,
  fetchPolicyholderUserSuccess,
  fetchPolicyholderUserRequest,
  fetchMunicipalityLocationRequest,
  fetchMunicipalitySuccess,
  fetchMunicipalityLocationFailure,
  fetchAllLocationFailure,
  fetchAllLocationSuccess,
  fetchAllLocationRequest,
  fetchVillageLocationRequest,
  fetchVillageSuccess,
  fetchVillageLocationFailure,
  createPolicyHolderInsureeRequest,
  createPolicyHolderInsureeSuccess,
  createPolicyHolderInsureeFailure,
  updatePolicyHolderInsureeFailure,
  updatePolicyHolderInsureeRequest,
  updatePolicyHolderInsureeSuccess,
  deletePolicyHolderInsureeRequest,
  deletePolicyHolderInsureeSuccess,
  deletePolicyHolderInsureeFailure,
  printInsureeFailure,
  printInsureeRequest,
  printInsureeSuccess,
  fetchMutationSuccess,
  fetchFileRequest,
  fetchFiletemplateSuccess,
  fetchDocumentRequest,
  fetchUploadedSuccess,
  fetchDeletedSuccess,
  fetchContractRequest,
  fetchContractFailure,
  fetchContractSuccess,
  fetchPaymentRequest,
  fetchPaymentSuccess,
  fetchPaymentFailure,
  fetchPaymentByIdFailure,
  fetchPaymentByIdRequest,
  fetchPaymentByIdSuccess,
  fetchEndDateSuccess,
  fetchEndDateFailure,
  fetchEndDateRequest,
  fetchCreateContractRequest,
  fetchCreateContractSuccess,
  fetchCreateContractFailure,
  fetchContractDetailsRequest,
  fetchContractDetailsSuccess,
  fetchContractDetailsFailure,
  fetchPolicyholderInsureeRequest,
  fetchPolicyholderInsureeSuccess,
  fetchPolicyholderInsureeFailure,
  deleteContractRequest,
  deleteContractSuccess,
  deleteContractFailure,
  updatePaymentFailure,
  updatePaymentSuccess,
  updatePaymentRequest,
  submitContractFailure,
  submitContractSuccess,
  submitContractRequest,
  deleteContractDetailFailure,
  deleteContractDetailSuccess,
  deleteContractDetailRequest,
  fetchValidationRequest,
  fetchValidationSuccess,
  fetchValidationFailure,
  printPolicyholderRequest,
  printPolicyholderSuccess,
  printPolicyholderFailure,
  fetchVerificationListRequest,
  fetchVerificationListSuccess,
  fetchVerificationListFailure,
  fetchVerificationCodeRequest,
  fetchVerificationCodeSuccess,
  fetchVerificationCodeFailure,
  fetchVerificationHistoryRequest,
  fetchVerificationHistorySuccess,
  fetchVerificationHistoryFailure,
  fetchPoliciesByInsureeRequest,
  fetchPoliciesByInsureeSuccess,
  fetchPoliciesByInsureeFailure,
  fetchLatestActiveInsureePolicyRequest,
  fetchLatestActiveInsureePolicySuccess,
  fetchLatestActiveInsureePolicyFailure,
  fetchGuardianRequest,
  fetchGuardianSuccess,
  fetchGuardianFailure,
  fetchHealthFacilityRequest,
  fetchHealthFacilitySuccess,
  fetchHealthFacilityFailure,
  fetchInsureeHealthFacilityFailure,
  fetchInsureeHealthFacilityRequest,
  fetchInsureeHealthFacilitySuccess,
  fetchStatusHealthFacilityFailure,
  fetchStatusHealthFacilitySuccess,
  fetchStatusHealthFacilityRequest,
  printCareSheetRequest,
  printCareSheetSuccess,
  printCareSheetFailure,
  createFosaUserRequest,
  createFosaUserSuccess,
  createFosaUserFailure,
  fetchClaimTableRequest,
  fetchClaimTableSuccess,
  fetchClaimTableFailure,
  fetchInsureeClaimServiceFailure,
  fetchInsureeClaimServiceSuccess,
  fetchInsureeClaimServiceRequest,
  fetchInsureeItemServiceRequest,
  fetchInsureeItemServiceSuccess,
  fetchInsureeItemServiceFailure,
  fetchPathologyRequest,
  fetchPathologySuccess,
  fetchPathologyFailure,
  fetchConsultantHfSuccess,
  fetchConsultantHfFailure,
  fetchConsultantHfRequest,
  fetchClaimByIdRequest,
  fetchClaimByIdSuccess,
  fetchClaimByIdFailure,
  fetchClaimHistoryByIdRequest,
  fetchClaimHistoryByIdSuccess,
  fetchClaimHistoryByIdFailure,
  fetchAdminIdRequest,
  fetchAdminIdSuccess,
  fetchAdminIdFailure,
  createClaimRequest,
  createClaimSuccess,
  createClaimFailure,
  fetchInsureeByUuidFailure,
  fetchInsureeByUuidRequest,
  fetchInsureeByUuidSuccess,
  submitClaimRequest,
  submitClaimSuccess,
  submitClaimFailure,
  updateClaimRequest,
  updateClaimSuccess,
  updateClaimFailure,
  createAttachmentFailure,
  createAttachmentSuccess,
  createAttachmentRequest,
  fetchAttachmentsFailure,
  fetchAttachmentsSuccess,
  fetchAttachmentsRequest,
  fetchMedicalStaffInsureeFailure,
  fetchMedicalStaffInsureeSuccess,
  fetchMedicalStaffInsureeRequest,
  getConsultantHfInsureeSuccess,
  getConsultantHfInsureeFailure,
  getConsultantHfInsureeRequest,
  fetchFosaUserRequest,
  fetchFosaUserSuccess,
  fetchFosaUserFailure,
  fetchPreAuthTableRequest,
  fetchPreAuthTableSuccess,
  fetchPreAuthTableFailure,
  fetchPreauthFormDataRequest,
  fetchPreauthFormDataSuccess,
  fetchPreauthFormDataFailure,
  fetchPreauthHistoryRequest,
  fetchPreauthHistorySucess,
  fetchPreauthHistoryFailure,
  GetPreauthDataRequest,
  GetPreauthDataSuccess,
  GetPreauthDataFailure,
  createPreAuthRequest,
  createPreAuthSuccess,
  createPreAuthFailure,
  fetchNotificationsRequest,
  fetchNotificationsSucess,
  fetchNotificationsFailure,
  fetchAdminTableRequest,
  // admin
  fetchAdminTableSuccess,
  fetchAdminTableFailure,
  fetchAdminDataRequest,
  fetchAdminSuccess,
  fetchAdminFailure,
  fetchAdminDataSuccess,
  editAdminRequest,
  editAdminSuccess,
  editAdminFailure,
  createAdminRequest,
  createAdminSuccess,
  createAdminFailure,
  fetchAdminRequest,
  deleteAdminRequest,
  deleteAdminSuccess,
  deleteAdminFailure,
  fetchRolesRequest,
  fetchRolesSuccess,
  fetchRolesFailure,
  fetchFosaMedicalItemsRequest,
  fetchFosaMedicalItemsSuccess,
  fetchFosaMedicalItemsFailure,
  fetchFosaMedicalServicesRequest,
  fetchFosaMedicalServicesSuccess,
  fetchFosaMedicalServicesFailure,
  fetchCurrentUserWithRolesDataRequest,
  fetchSubstituteRequest,
  fetchSubstituteSuccess,
  fetchSubstituteFailure,
  fetchStatusHealthFacilitySubstituteRequest,
  fetchStatusHealthFacilitySubstituteSuccess,
  fetchStatusHealthFacilitySubstituteFailure,
  fetchConventionnementByHFIdRequest,
  fetchConventionnementByHFIdSuccess,
  fetchConventionnementByHFIdFailure,
  fetchHealthFacilitiesWithPackageRequest,
  fetchHealthFacilitiesWithPackageSuccess,
  fetchHealthFacilitiesWithPackageFailure,
  fetchHealthFacilitiesWithProductBundleRequest,
  fetchHealthFacilitiesWithProductBundleSuccess,
  fetchHealthFacilitiesWithProductBundleFailure,
  // admin
  fetchClaimChatRequest,
  fetchClaimChatSuccess,
  fetchClaimChatFailure,
  createClaimChatRequest,
  createClaimChatSuccess,
  createClaimChatFailure,
  resetUsernameError,
} from "./store/actions/exampleAction";
import { FETCH_LOCATION_SUCCESS } from "./store/actions/types";
import {
  decodeId,
  formatDateFromISO,
  formatGQLString,
  formatMutation,
  formatPageQuery,
  formatPageQueryWithCount,
} from "./utils/helper";
import {
  ActivityCode,
  GedToken,
  POLICY_HOLDER_SUCCESS,
  activityData,
} from "./utils/constant";
import moment from "moment";
import { CLAIM_STATUS_SUBMITTED } from "./utils/statusMap";

export const resetUsernameErrorDispatch = () => {
  return (dispatch) => {
    dispatch(resetUsernameError());
  };
};

export const fetchData = (guardianData) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());

    try {
      const { data } = await client.query({
        query: gql`
            query GetSonDaughter {
                getSonDaughter(newGuardianId: 12, oldGuardianId: 32) {
                    totalCount
                    edgeCount
                    edges {
                        node {
                            id
                            uuid
                            chfId
                            lastName
                            otherNames
                            camuNumber
                            gender {
                                code
                            }
                            dob
                        }
                    }
                }
            }
        `,
      });
      dispatch(fetchDataSuccess(data));
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchDataFailure(error.message));
    }
  };
};

export const refreshAuthToken = (user) => {
  return async (dispatch) => {
    dispatch(fetchRefreshTokenDataRequest());
    try {
      const mutationQuery = gql`
          mutation RefreshToken {
              refreshToken {
                  payload
                  refreshExpiresIn
                  token
                  refreshToken
              }
          }
      `;
      const { data } = await client.mutate({
        mutation: mutationQuery,
      });
      dispatch(fetchRefreshTokenDataSuccess(data));
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchRefreshTokenDataFailure(error.message));
    }
  };
};
export const login = (user) => {
  return async (dispatch) => {
    dispatch(fetchLoginDataRequest());
    try {
      const mutationQuery = gql`
          mutation Authenticate(
              $username: String!
              $password: String!
              $isFosaUser: Boolean!
          ) {
              tokenAuth(
                  username: $username
                  password: $password
                  isFosaUser: $isFosaUser
              ) {
                  refreshExpiresIn
                  payload
                  token
                  refreshToken
              }
          }
      `;
      const { data } = await client.mutate({
        mutation: mutationQuery,
        variables: {
          username: user.userName,
          password: user.password,
          isFosaUser: true,
        },
      });
      console.log("setuserData", data);

      dispatch(fetchLoginDataSuccess(data));
    } catch (error) {
      // Log and dispatch action in case of error
      console.error("Error fetching data:", error);
      dispatch(fetchLoginDataFailure(error.message));
    }
  };
};

const formatUserData = (propsData) => {
  return {
    tradeName: propsData.trdeName ? propsData.trdeName : "",
    jsonExt: propsData.shortName
      ? `{"shortName":"${propsData.shortName}"}`
      : "",
    otherNames: propsData.firstName ? propsData.firstName : "",
    lastName: propsData.lastName ? propsData.lastName : "",
    phone: propsData.phone ? propsData.phone : "",
    email: propsData.emailAddress ? propsData.emailAddress : "",
    username: propsData.username ? propsData.username : "",
    password: propsData.password ? propsData.password : "",
    language: "en",
    districts: [],
    userTypes: "INTERACTIVE",
  };
};

export function formatJsonField(json) {
  return `"${JSON.stringify(json).replace(/\"/g, '\\"')}"`;
}

export const createUser = (userData) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    const jsonExtValue = {
      jsonExt: {
        jsonExt: {
          shortName: userData.shortName,
          niu: "",
          rccm: "",
          nbEmployees: "",
          activityCode: "",
          mainActivity: "",
          createdAt: "",
          activityCode: "",
        },
      },
    };
    try {
      const mutationQuery = `
      mutation {
        createPhPortalUser(
          input: {
            tradeName: "${userData.tradeName}",
            jsonExt: "${JSON.stringify(jsonExtValue.jsonExt).replace(
        /"/g,
        '\\"'
      )}",
              otherNames: "${userData.firstName}",
              lastName: "${userData.lastName}",
              phone: "${userData.phone}",
              email: "${userData.emailAddress}",
              language: "en",
              districts: [${decodeId(userData.district)}],
              username: "${userData.username}",
              password: "${userData.password}",
              userTypes:  [
                INTERACTIVE
              ]
            }
          ) {
            success
            message
          }
        }
      `;

      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      dispatch(fetchDataSuccess(data));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchDataFailure(error.message));
    }
  };
};

export const fetchAllRegions = () => {
  return async (dispatch) => {
    dispatch(fetchLocationRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                locationsStrNotAuth(type: "R", str: "") {
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            id
                            uuid
                            type
                            code
                            name
                            parent {
                                id
                                uuid
                                code
                                name
                                type
                            }
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        dispatch(fetchLocationSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchLocationFailure(error.message));
    }
  };
};
export const fetchAllDistrict = (region) => {
  return async (dispatch) => {
    dispatch(fetchDistrictLocationRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                locationsStrNotAuth(type: "D",parent_Uuid: "${region}")
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,uuid,type,code,name,malePopulation,femalePopulation,otherPopulation,families,
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        dispatch(fetchDistrictLocationSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchDistrictLocationFailure(error.message));
    }
  };
};

export const forgotPassword = (user) => {
  console.log("====> user", user);
  return async (dispatch) => {
    dispatch(fetchForgotDataRequest());
    try {
      // const mutationQuery = gql`
      //     mutation resetPassword($input: ResetPasswordMutationInput!) {
      //         resetPassword(input: $input) {
      //             clientMutationId
      //             success
      //             error
      //         }
      //     }
      // `;
      const mutationQuery = gql`
          mutation {
            newPasswordRequest(email:"${user.email}", fromWhatEnv:"fosa"){
              success
              message
            }
          }
      `;
      // Generate a unique client mutation id
      const { data } = await client.mutate({
        mutation: mutationQuery,
        // variables: {
        //   input: {
        //     username: user.userName,
        //     isPortal: true,
        //   },
        // },
      });
      dispatch(fetchForgotDataSuccess(data));
    } catch (error) {
      // Log and dispatch action in case of error
      console.error("Error fetching data:", error);
      dispatch(fetchForgotDataFailure(error.message));
    }
  };
};
export const resetPassword = (user) => {
  return async (dispatch) => {
    dispatch(fetchResetDataRequest());
    try {
      const mutationQuery = gql`
          mutation setPassword($input: SetPasswordMutationInput!) {
              setPassword(input: $input) {
                  clientMutationId
                  success
                  error
              }
          }
      `;
      const { data } = await client.mutate({
        mutation: mutationQuery,
        variables: {
          input: {
            username: `${user.userName}`,
            isPortal: true,
            newPassword: `${user.newPassword}`,
          },
        },
      });
      dispatch(fetchResetDataSuccess(data));
    } catch (error) {
      // Log and dispatch action in case of error
      console.error("Error fetching data:", error);
      dispatch(fetchResetDataFailure(error.message));
    }
  };
};
export const loadUser = async (token) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/core/users/current_user/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const res = await response.json();
    return res;
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error; // Rethrow the error so that it can be handled further up the chain if needed
  }
};

export const loadingUser = (token) => {
  return async (dispatch) => {
    dispatch(fetchCurrentUserDataRequest());
    try {
      const userData = await loadUser(token); // Pass the token here
      const { users } = await getAdminUserQuery(userData.id);
      dispatch(fetchCurrentUserDataSuccess(userData));
      dispatch(
        fetchCurrentUserWithRolesDataRequest(users?.edges[0]?.node?.iUser)
      );
    } catch (error) {
      console.error("Error fetching user data:", error);
      dispatch(fetchCurrentUserDataFailure(error.message));
    }
  };
};

export const fetchAllContributionPlan = () => {
  return async (dispatch) => {
    dispatch(fetchContributionPlanBundleRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                contributionPlanBundle(isDeleted: false) {
                    totalCount

                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            id
                            code
                            name
                            periodicity
                            dateValidFrom
                            dateValidTo
                            isDeleted
                            replacementUuid
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchContributionPlanBundleSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchContributionPlanBundleFailure(error.message));
    }
  };
};
export const fetchContributionPlanByID = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchContributionPlanByIdBundleRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                policyHolderContributionPlanBundle(policyHolder_Id: "${decodeId(
          uuid
        )}",orderBy: "-date_created",version: 1)
          {
            totalCount

            pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
            edges
            {
            node
            {
            id
            contributionPlanBundle{id, code, name, periodicity, dateValidFrom, dateValidTo, isDeleted, replacementUuid}
            }
            }
            }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchContributionPlanByIdBundleSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchContributionPlanByIdBundleFailure(error.message));
    }
  };
};

export const fetchInsureeByName = (chfId, camuNumer = null) => {
  return async (dispatch) => {
    dispatch(fetchInsureeByIdRequest());
    try {
      const getParams = (chfId, camuNumer = null) => {
        if (camuNumer) {
          return `camuNumber_Icontains:"${camuNumer}"`;
        }
        return `chfId_Icontains:"${chfId}"`;
      };
      const { data } = await client.query({
        query: gql`
            {
                insurees(${getParams(chfId, camuNumer)}, ignoreLocation:true)
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,uuid,chfId,lastName,otherNames,dob,age,validityFrom,validityTo,gender{code},family{id,uuid,headInsuree{
                            lastName
                            otherNames
                            chfId
                            camuNumber
                        }},photo{folder,filename,photo},gender{code, gender, altLanguage},photoUrl,camuNumber,status,statusComment,biometricsStatus,biometricsIsMaster,healthFacility{id, uuid, code, name, level, jsonExt, fosaCode, servicesPricelist{id, uuid}, itemsPricelist{id, uuid}, location{id,uuid,code,name,type, parent{id,uuid,code,name,type}}},jsonExt,createdBy,policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchInsureeByIdSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchInsureeByIdFailure(error.message));
    }
  };
};

export const fetchPolicyHolderByInsuree = (params) => {
  return async (dispatch) => {
    dispatch(fetchPolicyHolderByInsureeRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query PolicyHolderInsurees{
                policyHolderInsuree(${params.join(" ")}) {
                totalCount
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    node {
                        id
                        dateValidFrom
                        dateValidTo
                        employerNumber
                        jsonExt
                        lastPolicy {
                            id
                        }
                        policyHolder {
                            id
                        }
                        insuree {
                            id
                            uuid
                            chfId
                            camuNumber
                            lastName
                            otherNames
                            jsonExt
                            status
                            gender {
                                code
                            }
                            age
                            dob
                            photoUrl
                            family {
                                id
                                uuid
                                headInsuree {
                                    lastName
                                    otherNames
                                    chfId
                                    camuNumber
                                }
                            }
                            policyholderinsureeSet {
                                edges {
                                    node {
                                        policyHolder {
                                            tradeName
                                            code
                                        }
                                    }
                                }
                            }
                        }
                        contributionPlanBundle {
                            id
                            code
                            name
                            periodicity
                            dateValidFrom
                            dateValidTo
                            isDeleted
                            replacementUuid
                        }
                        isDeleted
                        replacementUuid
                    }
                }
            }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchPolicyHolderByInsureeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPolicyHolderByInsureeFailure(error.message));
    }
  };
};

export const fetchPolicyHolderByInsureeAutoRefresh = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchPolicyHolderByInsureeRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                policyHolderInsuree(policyHolder_Id: "${decodeId(
          uuid
        )}",first: 10,isDeleted: false,orderBy: ["insuree"])
      {
            totalCount

            pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
            edges
            {
            node
            {
            id,dateValidFrom,dateValidTo,employerNumber,jsonExt,lastPolicy{id},policyHolder{id},insuree{id, uuid, chfId, camuNumber, lastName, otherNames, jsonExt, status, gender{code}, age, family{id,uuid,headInsuree{lastName otherNames chfId camuNumber}}, policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}},contributionPlanBundle{id, code, name, periodicity, dateValidFrom, dateValidTo, isDeleted, replacementUuid},isDeleted,replacementUuid
            }
            }
            }
            }
        `,
      });
      console.log("Data received:", data);
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchPolicyHolderByInsureeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPolicyHolderByInsureeFailure(error.message));
    }
  };
};
export const fetchPolicyHolderByInsureeByFilter = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchPolicyHolderByInsureeRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                policyHolderInsuree(${uuid})
            {
                totalCount

                pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                edges
                {
                    node
                    {
                        id,dateValidFrom,dateValidTo,employerNumber,jsonExt,lastPolicy{id},policyHolder{id},insuree{id, uuid, chfId, camuNumber, lastName, otherNames, jsonExt, status, gender{code}, age, family{id,uuid,headInsuree{lastName otherNames chfId camuNumber}}, policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}},contributionPlanBundle{id, code, name, periodicity, dateValidFrom, dateValidTo, isDeleted, replacementUuid},isDeleted,replacementUuid
                    }
                }
            }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchPolicyHolderByInsureeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPolicyHolderByInsureeFailure(error.message));
    }
  };
};
export const fetchPolicyHolderInfo = (policyholderId) => {
  return async (dispatch) => {
    dispatch(fetchPolicyholderUserRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query PolicyHolderUser {
                policyHolderUser(user_Id: "${policyholderId}") {
                    totalCount
                    edgeCount
                    edges {
                        node {
                            policyHolder {
                                id
                                jsonExt
                                code
                                tradeName
                                address
                                phone
                                fax
                                email
                                contactName
                                legalForm
                                activityCode
                                accountancyAccount
                                bankAccount
                                paymentReference
                                isApproved
                                requestNumber
                                dateValidFrom
                                locations{id, uuid, code, name, type, parent{id,uuid,code,name,type,parent{id,uuid,code,name,type,parent{id,uuid,code,name,type}}}}
                                isSubmit
                                formPhPortal
                                isApproved
                                isRework
                                reworkOption
                                reworkComment
                            }
                            user {
                                iUser {
                                    otherNames
                                    loginName
                                }
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchPolicyholderUserSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPolicyholderUserFailure(error.message));
    }
  };
};

export const fetchAllMunicipality = (district) => {
  return async (dispatch) => {
    dispatch(fetchMunicipalityLocationRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                locationsStrNotAuth(type: "W",str: "",parent_Uuid: "${district}")
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,uuid,type,code,name,parent{id,uuid,code,name,type,parent{id,uuid,code,name,type,parent{id,uuid,code,name,type}}}
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        dispatch(fetchMunicipalitySuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchMunicipalityLocationFailure(error.message));
    }
  };
};

export const fetchLocationsByType = (type) => {
  return async (dispatch) => {
    dispatch(fetchAllLocationRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                locationsStrNotAuth(type: "${type}", str: "") {
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            id
                            uuid
                            type
                            code
                            name
                            parent {
                                id
                                uuid
                                code
                                name
                                type
                            }
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        dispatch(fetchAllLocationSuccess(data, type)); // Pass type to reducer
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchAllLocationFailure(error.message));
    }
  };
};

export const fetchAllVillages = (Village) => {
  return async (dispatch) => {
    dispatch(fetchVillageLocationRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                locationsStrNotAuth(type: "V",str: "",parent_Uuid: "${Village}")
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,uuid,type,code,name,parent{id,uuid,code,name,type,parent{id,uuid,code,name,type,parent{id,uuid,code,name,type}}}
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        dispatch(fetchVillageSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchVillageLocationFailure(error.message));
    }
  };
};

function dateTimeToDate(date) {
  try {
    return date?.split("T")[0];
  } catch (error) {
    console.error("===> dateTimeToDate error", error);
    return date;
  }
}

function formatPolicyHolderGQL(policyHolder, phId, activePage) {
  return `
  ${!!phId.id ? `id: "${decodeId(phId.id)}"` : ""}
        ${!!policyHolder.code
      ? `code: "${formatGQLString(policyHolder.code)}"`
      : ""
    }
        ${!!policyHolder.tradeName
      ? `tradeName: "${formatGQLString(policyHolder.tradeName)}"`
      : ""
    }
        ${!!policyHolder.village
      ? `locationsId: ${decodeId(policyHolder.village)}`
      : ""
    }
        ${!!policyHolder.address
      ? `address: "${JSON.stringify({
        address: policyHolder.address,
      }).replace(/"/g, '\\"')}"`
      : ""
    }
        ${!!policyHolder.phone
      ? `phone: "${formatGQLString(policyHolder.phone)}"`
      : ""
    }
        ${!!policyHolder.fax
      ? `fax: "${formatGQLString(policyHolder.fax)}"`
      : ""
    }
        ${!!policyHolder.email
      ? `email: "${formatGQLString(policyHolder.email)}"`
      : ""
    }
        ${!!policyHolder.contactName
      ? `contactName: "${JSON.stringify({
        contactName: policyHolder.contactName,
      }).replace(/"/g, '\\"')}"`
      : ""
    }
        ${!!policyHolder.legalForm ? `legalForm: ${policyHolder.legalForm}` : ""
    }
        ${!!policyHolder.activityCode
      ? `activityCode: ${policyHolder.activityCode}`
      : ""
    }
        ${!!policyHolder.accountancyAccount
      ? `accountancyAccount: "${formatGQLString(
        policyHolder.accountancyAccount
      )}"`
      : ""
    }
        ${!!policyHolder.paymentReference
      ? `paymentReference: "${formatGQLString(
        policyHolder.paymentReference
      )}"`
      : ""
    }
        ${!!policyHolder.dateValidFrom
      ? `dateValidFrom: "${dateTimeToDate(policyHolder.dateValidFrom)}"`
      : ""
    }
        ${!!policyHolder.dateValidTo
      ? `dateValidTo: "${dateTimeToDate(policyHolder.dateValidTo)}"`
      : ""
    }
        ${!!policyHolder.jsonExt
      ? `jsonExt: "${JSON.stringify(policyHolder.jsonExt).replace(
        /"/g,
        '\\"'
      )}"`
      : ""
    }
        ${!!policyHolder.bankAccount
      ? `bankAccount: "${JSON.stringify(policyHolder.bankAccount).replace(
        /"/g,
        '\\"'
      )}"`
      : ""
    }
       ${`isReview: ${activePage > 0 ? true : false}`} 
       ${`isSubmit: ${activePage == 2 ? true : false}`} 
       ${activePage == 2 ? `status:"Pending"` : ""}
    `;
}

// export function fetchMutation(clientMutationId) {
//   return async (dispatch) => {
//     const payload = formatPageQuery(
//       "mutationLogs",
//       [`clientMutationId: "${clientMutationId}"`],
//       [
//         "id",
//         "status",
//         "error",
//         "clientMutationId",
//         "clientMutationLabel",
//         "clientMutationDetails",
//         "requestDateTime",
//       ]
//     );
//     const { data } = await client.mutate({
//       mutation: gql`
//         ${payload}
//       `,
//     });
//     console.log("responsemutation", data);
//     dispatch(fetchMutationSuccess(data));
//     // return graphql(payload, "CORE_MUTATION");
//   };
// }
export function fetchMutation(clientMutationId) {
  return async (dispatch) => {
    const payload = formatPageQuery(
      "mutationLogs",
      [`clientMutationId: "${clientMutationId}"`],
      [
        "id",
        "status",
        "error",
        "clientMutationId",
        "clientMutationLabel",
        "clientMutationDetails",
        "requestDateTime",
      ]
    );
    const { data } = await client.mutate({
      mutation: gql`
          ${payload}
      `,
    });
    dispatch(fetchMutationSuccess(data));
    // return graphql(payload, "CORE_MUTATION");
  };
}

const findCodeByValue = (userData) => {
  for (let i = 0; i < activityData.length; i++) {
    if (activityData[i].val == userData?.activityCode) {
      return activityData[i].code;
    }
  }
  return undefined;
};

export const updatePolicyholderUser = (
  userData,
  phId,
  activePage,
  handleNavigation,
  currentUserId
) => {
  const activityCodeJson = findCodeByValue(userData);
  return async (dispatch, getState) => {
    const updatedCreatedAt = getState()?.profileReducer?.locationResponseData;
    const findCreatedAt = (userData) => {
      for (let i = 0; i < updatedCreatedAt.length; i++) {
        if (updatedCreatedAt[i].code == userData) {
          return updatedCreatedAt[i];
        }
      }
      return undefined;
    };
    const updatedPolicyholderData = {
      ...userData,
      bankAccount: {
        bankAccount: {
          bank: userData.bank,
          lockerCode: userData.lockerCode,
          accountNb: userData.accountNb,
          bankKey: userData.bankKey,
        },
      },
      locationsId: userData.village,
      jsonExt: {
        jsonExt: {
          shortName: userData.shortName,
          niu: userData.niu,
          rccm: userData.rccm,
          nbEmployees: userData.nbEmployees,
          mainActivity: userData.mainActivity,

          activityCode: userData.activityCode?.code,
        },
      },
    };
    dispatch(fetchDataRequest());
    try {
      let mutationQuery = formatMutation(
        "updatePolicyHolder",
        formatPolicyHolderGQL(
          {
            ...updatedPolicyholderData,
            ...updatedPolicyholderData?.jsonExt,
            jsonExt: {
              jsonExt: {
                ...updatedPolicyholderData?.jsonExt?.jsonExt,
                activityCode: `${activityCodeJson}`,
                createdAt: findCreatedAt(userData.createdAt),
              },
            },
          },
          phId,
          activePage
        ),
        "UpdatePolicyHolder.mutationLabel"
      );

      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(fetchDataSuccess(data));
      if (currentUserId) {
        dispatch(fetchPolicyHolderInfo(currentUserId));
      }
      if (data && activePage == 2) {
        handleNavigation(
          `${POLICY_HOLDER_SUCCESS}/:id=${userData.requestNumber}`
        );
      }
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchDataFailure(error.message));
    }
  };
};

export const createContribtionPolicyholder = (userData, phId) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      const mutationQuery = `
      mutation {
        createPolicyHolderContributionPlanBundle(
          input: {            
          policyHolderId: "${decodeId(phId.id)}"
          contributionPlanBundleId: "${decodeId(
        userData.contributionPlanBundle
      )}"
          dateValidFrom: "${dateTimeToDate(userData.dateValidFrom)}"
          }
        ) {
          clientMutationId
          internalId
        }
      }
      `;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      dispatch(fetchDataSuccess(data));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchDataFailure(error.message));
    }
  };
};

export const createPolicyHolderInsuree = (userData, currentUser) => {
  return async (dispatch) => {
    dispatch(createPolicyHolderInsureeRequest());

    const jsonExtValue = JSON.stringify({
      calculation_rule: {
        income: userData.values.income,
        rate: 0,
      },
    });
    try {
      let mutationQuery = formatMutation(
        "createPolicyHolderInsuree",
        `
                  policyHolderId:"${decodeId(currentUser?.id)}",
                  insureeId: ${decodeId(userData["0"].id)},
                  contributionPlanBundleId: "${decodeId(
          userData.values.contributionPlan
        )}",
                  jsonExt: "${jsonExtValue.replace(/"/g, '\\"')}",
                  ${userData.values.employeeNo
          ? `employerNumber:"${userData.values.employeeNo}"`
          : ""
        },
                  dateValidFrom: "${formatDateFromISO(
          userData.values.validFrom
        )}",
                  ${userData.values.validTo
          ? `dateValidTo: "${formatDateFromISO(
            userData.values.validTo
          )}"`
          : ""
        }
        `,
        "createPolicyHolderInsuree.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(createPolicyHolderInsureeSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(createPolicyHolderInsureeFailure(error.message));
    }
  };
};

export const updatePolicyHolderInsuree = (userData, currentUser, rowData) => {
  return async (dispatch) => {
    dispatch(updatePolicyHolderInsureeRequest());
    const jsonExtValue = JSON.stringify({
      calculation_rule: {
        income: userData.values.income,
      },
    });
    try {
      const mutationQuery = formatMutation(
        "updatePolicyHolderInsuree",
        `id:"${decodeId(rowData)}"
              policyHolderId:"${decodeId(currentUser)}",
              insureeId: ${decodeId(userData["0"].id)},
              contributionPlanBundleId: "${decodeId(
          userData.values.contributionPlan
        )}",
              jsonExt: "${jsonExtValue.replace(/"/g, '\\"')}",
              ${userData.values.employeeNo
          ? `employerNumber:"${userData.values.employeeNo}"`
          : ""
        },
              dateValidFrom: "${dateTimeToDate(userData.values.validFrom)}",
              ${userData.values.validTo
          ? `dateValidTo: "${dateTimeToDate(userData.values.validTo)}"`
          : ""
        }`,
        "updatePolicyHolderInsuree.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(updatePolicyHolderInsureeSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(updatePolicyHolderInsureeFailure(error.message));
    }
  };
};

export const deletePolicyHolderInsuree = (userData) => {
  return async (dispatch) => {
    dispatch(deletePolicyHolderInsureeRequest());
    try {
      const mutationQuery = formatMutation(
        "deletePolicyHolderInsuree",
        `
              uuids: ["${decodeId(userData)}"]
        `,
        "deletePolicyHolderInsuree.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(deletePolicyHolderInsureeSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(deletePolicyHolderInsureeFailure(error.message));
    }
  };
};

function formatPrintInsuree(edited) {
  // console.log(JSON.parse(edited?.insuree?.jsonExt), "format");
  const insureeJson = JSON.parse(edited?.insuree?.jsonExt);

  const formatPrint = `uuid: "${edited?.insuree?.uuid
    }",  isEmail: ${false},reportName: "${insureeJson?.insureeEnrolmentType}"`;
  return formatPrint;
}

export const printInsureeReport = (edited) => {
  return async (dispatch) => {
    dispatch(printInsureeRequest());
    try {
      const mutationQuery = `
      mutation SendNotification{
        sentNotification(${formatPrintInsuree(edited)}) {
        success
        message
        data
}}
      `;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(printInsureeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(printInsureeFailure(error.message));
    }
  };
};
export const loginCnss = () => {
  const loginUrl = `${process.env.REACT_APP_GED_URL}/oauth/token`;
  const username = process.env.REACT_APP_USERNAME;
  const password = process.env.REACT_APP_PASSWORD;
  const base64CredentialsLog = process.env.REACT_APP_BASE64_CREDENTIALS;
  const loginData = new URLSearchParams();
  loginData.append("username", username);
  loginData.append("password", password);
  loginData.append("grant_type", "password");
  loginData.append("scope", "read");

  // const base64Credentials = btoa(base64CredentialsLog);
  const base64Credentials = btoa("kiyas:Y@123$%^23*");

  fetch(loginUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${base64Credentials}`,
    },
    body: loginData.toString(),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Login failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      const accessToken = data.access_token;
      localStorage.setItem("GED_token", accessToken);
    })
    .catch((error) => {
      console.error("Login error:", error);
    });
};

export const documentTemplate = (template) => {
  const GedTokenDocs = localStorage.getItem("GED_token");
  return async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_GED_URL}/documenttemplate/search?templateType=${template}&offset=0&limit=10`;
    const headers = {
      Authorization: `Bearer ${GedTokenDocs}`,
      "Content-Type": "application/json",
    };

    fetch(`${apiUrl}`, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        const templatename = res;
        dispatch(fetchFiletemplateSuccess(templatename));
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };
};

export const documentUpload = (fileData, phId, templateName) => {
  const Ged_Token = localStorage.getItem("GED_token");
  return async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_GED_URL}/documents/upload`;
    const headers = {
      Authorization: `Bearer ${Ged_Token}`,
    };
    const formData = new FormData();
    formData.append("fileId", phId);
    formData.append("file", fileData);
    formData.append("documentName", templateName);
    formData.append("isAdditionalFlow", false);
    fetch(`${apiUrl}`, {
      method: "POST",
      headers: headers,
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        const resUpload = res;
        console.log("resUpload", resUpload);
        dispatch(fetchUploadedSuccess(resUpload));
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };
};

export const documentFileSearch = (requestBody, isRejectFile = false) => {
  const Ged_Token = localStorage.getItem("GED_token");
  return async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_GED_URL}/file/search?checkRejectFile=${isRejectFile}`;
    const headers = {
      Authorization: `Bearer ${Ged_Token}`,
      "Content-Type": "application/json",
    };
    const fileReq = { fileNumber: requestBody.requestNumber };
    fetch(`${apiUrl}`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(fileReq),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        const fileRequestData = res;
        dispatch(fetchFileRequest(fileRequestData));
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };
};

export const documentsSearch = (requestBody) => {
  const Ged_Token = localStorage.getItem("GED_token");
  return async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_GED_URL}/document/search`;
    const headers = {
      Authorization: `Bearer ${Ged_Token}`,
      "Content-Type": "application/json",
    };
    const fileReq = {
      fileNumber: requestBody.code
        ? requestBody.code
        : requestBody.requestNumber,
    };
    fetch(`${apiUrl}`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(fileReq),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        const fileRequestData = res;
        dispatch(fetchDocumentRequest(fileRequestData));
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };
};

export const documentFileCreate = (File) => {
  const Ged_Token = localStorage.getItem("GED_token");
  return async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_GED_URL}/file/create?isUpdate=false&isDocVerified=true`;
    const headers = {
      Authorization: `Bearer ${Ged_Token}`,
      "Content-Type": "application/json",
    };
    const fileReq = { action: `SUBMIT`, fileId: File?.[0]?.id };
    fetch(`${apiUrl}`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(fileReq),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        const fileRequestData = res;
        // dispatch(fetchFileRequest(fileRequestData));
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };
};
export const documentDelete = (File) => {
  const Ged_Token = localStorage.getItem("GED_token");
  return async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_GED_URL}/document/delete?documentId=${File}`;
    const headers = {
      Authorization: `Bearer ${Ged_Token}`,
      "Content-Type": "application/json",
    };
    const fileReq = { action: `SUBMIT`, fileId: File?.[0]?.id };
    fetch(`${apiUrl}`, {
      method: "DELETE",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        dispatch(fetchDeletedSuccess(response));
        return response.json();
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };
};

const CONTRACT_FULL_PROJECTION = () => [
  "id",
  "code",
  "amount",
  "amountNotified",
  "amountRectified",
  "amountDue",
  "dateApproved",
  "datePaymentDue",
  "state",
  "paymentReference",
  "amendment",
  "dateValidFrom",
  "dateValidTo",
  "isDeleted",
  "penaltyWaiveOffContract",
  "penaltyWaiveOffPayment",
  "penaltyWaiveOffContractReason",
  "penaltyWaiveOffPaymentReason",
  "policyHolder{id, code, tradeName}",
];

export function fetchContracts(params) {
  return async (dispatch) => {
    dispatch(fetchContractRequest());
    const payload = formatPageQueryWithCount(
      "contract",
      params,
      // { isDeleted: false, first: 10, orderBy: ["code"] },
      CONTRACT_FULL_PROJECTION()
    );
    try {
      const { data } = await client.query({
        query: gql(payload),
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchContractSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchContractFailure(error.message));
    }
  };
}

export const fetchPayments = (params) => {
  return async (dispatch) => {
    dispatch(fetchPaymentRequest());
    try {
      // const additionalFilter = { policyHolder: decodeId(uuid) };
      const { data } = await client.query({
        query: gql`
            query FetchPayments{
                payments(${params.join(" ,")}) {
                totalCount
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    node {
                        uuid
                        id
                        requestDate
                        expectedAmount
                        receivedAmountTransaction
                        receivedDate
                        receivedAmount
                        status
                        receiptNo
                        paymentCode
                        typeOfPayment
                        clientMutationId
                        validityTo
                        contractPenaltyAmount
                        parentPaymentPenalty
                        totalAmount
                        rejectedReason
                        contract {
                            code,
                            policyHolder {
                                tradeName
                            }
                            dateValidFrom
                            dateValidTo
                        }
                        parentPendingPayment
                        totalPendingAmount

                        isLocked

                    }
                }
            }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchPaymentSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPaymentFailure(error.message));
    }
  };
};
export const fetchPaymentById = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchPaymentByIdRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                payments(uuid: "${uuid}")
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            uuid,id,requestDate,expectedAmount,receivedAmountTransaction,receivedDate,receivedAmount,status,receiptNo,paymentCode,typeOfPayment,clientMutationId,validityTo,contractPenaltyAmount,parentPaymentPenalty,totalAmount,rejectedReason,contract {code,policyHolder{tradeName},dateValidFrom,dateValidTo},parentPendingPayment,totalPendingAmount,isLocked,officerCode,phoneNumber,transactionNo,origin,matchedDate,rejectedReason,dateLastSms,languageName,transferFee,clientMutationId
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchPaymentByIdSuccess(data)); // Pass type to reducer
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPaymentByIdFailure(error.message));
    }
  };
};

export const createContract = (contract) => {
  return async (dispatch) => {
    dispatch(fetchCreateContractRequest());
    const parsedStartDate = new Date(contract.dateValidFrom);

    if (parsedStartDate.getDate() !== 1) {
      parsedStartDate.setDate(1);
    }

    let date = moment.utc(contract.dateValidFrom);
    let endDate = moment.utc(contract.dateValidTo);

    let formattedDate = date.format("YYYY-MM-DD");

    const formattedStartDate = parsedStartDate.toISOString()?.split("T")[0];
    try {
      const mutationQuery = formatMutation(
        "createContract",
        `     
            ${!!contract.policyHolderId
          ? `policyHolderId: "${decodeId(contract.policyHolderId)}"`
          : ""
        }        
            ${!!contract.dateValidFrom
          ? `dateValidFrom: "${dateTimeToDate(
            parsedStartDate.getDate() !== 1
              ? formattedStartDate
              : formattedDate
          )}"`
          : ""
        }
            ${!!contract.dateValidTo
          ? `dateValidTo: "${dateTimeToDate(
            endDate.format("YYYY-MM-DD")
          )}"`
          : ""
        }
            ${`penaltyWaiveOffContract: ${contract.penaltyWaiveOffContract
          ? contract.penaltyWaiveOffContract
          : false
        }`}
            ${`penaltyWaiveOffPayment: ${contract.penaltyWaiveOffPayment
          ? contract.penaltyWaiveOffPayment
          : false
        }
            code: ""`}
`,
        "createContract.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(fetchCreateContractSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchCreateContractFailure(error.message));
    }
  };
};

export function validateEndDateByPeriodicity(startDate, policyholderId) {
  return async (dispatch) => {
    dispatch(fetchEndDateRequest());
    const parsedStartDate = startDate && new Date(startDate);

    startDate && parsedStartDate.setDate(1);

    const formattedStartDate =
      startDate && parsedStartDate.toISOString()?.split("T")[0];
    try {
      let mutationQuery = `query ValidateEnddateByPeriodicity {
        validateEnddateByPeriodicity(${formattedStartDate ? `startDate: "${formattedStartDate}"` : ""
        }  policyholderId:"${decodeId(policyholderId)}") 
    }`;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      dispatch(fetchEndDateSuccess(data));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchEndDateFailure(error.message));
    }
  };
}

export const fetchContractDetails = (params) => {
  return async (dispatch) => {
    dispatch(fetchContractDetailsRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                contractDetails(${params.join(" ")})
            {
                totalCount

                pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                edges
                {
                    node
                    {
                        id,jsonExt,contract{id},insuree{id, uuid, chfId, camuNumber, lastName, otherNames, jsonExt, status, gender{code}, age, family{id,uuid,headInsuree{lastName otherNames chfId camuNumber}}, policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}},contributionPlanBundle{id, code, name, periodicity, dateValidFrom, dateValidTo, isDeleted, replacementUuid},customField
                    }
                }
            }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchContractDetailsSuccess(data)); // Pass type to reducer
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchContractDetailsFailure(error.message));
    }
  };
};

export const fetchPolicyholderInsureePicker = (phId, contractId) => {
  return async (dispatch) => {
    dispatch(fetchPolicyholderInsureeRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                policyHolderInsuree(policyHolder_Id:" ${phId}",contractId: "${decodeId(
          contractId
        )}",isDeleted: false)
          {
            totalCount

            pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
            edges
            {
            node
            {
            id,
            employerNumber,
            jsonExt,
            user{
            id
            username
            iUser{
            id
            }
            }insuree{id, uuid, chfId, camuNumber, lastName, otherNames, jsonExt, status, gender{code}, age, family{id,uuid,headInsuree{lastName otherNames chfId camuNumber}}, policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}},contributionPlanBundle{id, code, name, periodicity, dateValidFrom, dateValidTo, isDeleted, replacementUuid}
            }
            }
            }
            }  `,
      });
      if (data) {
        dispatch(fetchPolicyholderInsureeSuccess(data)); // Pass type to reducer
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPolicyholderInsureeFailure(error.message));
    }
  };
};

function formatContractDetailsGQL(contractDetails) {
  return `
        ${!!contractDetails?.contract?.id
      ? `id: "${decodeId(contractDetails?.contract?.id)}"`
      : ""
    }
        ${!!contractDetails.contractId
      ? `contractId: "${contractDetails.contractId}"`
      : ""
    }
        ${!!contractDetails.values.insuree
      ? `insureeId: ${decodeId(contractDetails.values.insuree.id)}`
      : ""
    }
        ${!!contractDetails.contributionPlanBundle
      ? `contributionPlanBundleId: "${decodeId(
        contractDetails.contributionPlanBundle.id
      )}"`
      : ""
    }
        ${!!contractDetails.jsonExt
      ? `jsonExt:"${JSON.stringify(contractDetails.jsonExt).replace(
        /"/g,
        '\\"'
      )}"`
      : ""
    }
    `;
}

export const createContractDetails = (contractDetails) => {
  return async (dispatch) => {
    dispatch(fetchCreateContractRequest());

    try {
      const mutationQuery = formatMutation(
        "createContractDetails",
        formatContractDetailsGQL(contractDetails),
        "createContractDetails.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(fetchCreateContractSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchCreateContractFailure(error.message));
    }
  };
};

export const updateContractDetails = (contractDetails) => {
  return async (dispatch) => {
    dispatch(fetchCreateContractRequest());

    try {
      const mutationQuery = formatMutation(
        "updateContractDetails",
        formatContractDetailsGQL(contractDetails),
        "updateContractDetails.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(fetchCreateContractSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchCreateContractFailure(error.message));
    }
  };
};

export const deleteContractDetails = (contractId) => {
  return async (dispatch) => {
    dispatch(deletePolicyHolderInsureeRequest());
    try {
      const mutationQuery = formatMutation(
        "deletePolicyHolderInsuree",
        `
              uuids: ["${decodeId(contractId)}"]
        `,
        "deletePolicyHolderInsuree.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(deletePolicyHolderInsureeSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(deletePolicyHolderInsureeFailure(error.message));
    }
  };
};

export const deleteContract = (userData) => {
  return async (dispatch) => {
    dispatch(deleteContractRequest());
    try {
      const mutationQuery = formatMutation(
        "deleteContract",
        `
              uuids: ["${decodeId(userData)}"]
        `,
        "deleteContract.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(deleteContractSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(deleteContractFailure(error.message));
    }
  };
};

export function formatPaymentGQL(payment) {
  let totalReceivedAmount = 0;

  let receivedAmounts = [];
  // Check if receivedAmounts is a string and parse it, otherwise use it as it is
  if (typeof payment.receivedAmounts === "string") {
    try {
      receivedAmounts = JSON.parse(payment.receivedAmounts);
    } catch (error) {
      console.error(
        "Invalid JSON string for receivedAmounts:",
        payment.receivedAmounts
      );
    }
  } else if (Array.isArray(payment.receivedAmounts)) {
    receivedAmounts = payment.receivedAmounts;
  }

  // const formattedReceivedAmounts = receivedAmounts
  //   .map(
  //     (item) => `{ amount: "${item.amount}", receiptNo: "${item.receiptNo}" }`
  //   )
  //   .join(", ");
  const formattedReceivedAmounts = JSON.stringify(receivedAmounts);

  if (Array.isArray(payment.receivedAmounts)) {
    totalReceivedAmount = payment.receivedAmounts.reduce((total, item) => {
      return total + (item.amount ? parseFloat(item.amount) : 0);
    }, 0);
  }

  return `
    ${payment.uuid !== undefined && payment.uuid !== null
      ? `uuid: "${payment.uuid}"`
      : ""
    }
    ${!!payment.receivedDate ? `receivedDate: "${payment.receivedDate}"` : ""}
    ${!!payment.values.requestDate
      ? `requestDate: "${payment.values.requestDate}"`
      : ""
    }
    ${!!payment.values.matchedDate
      ? `matchedDate: "${payment.values.matchedDate}"`
      : ""
    }
    ${!!payment.values.dateLastSms
      ? `dateLastSms: "${payment.values.dateLastSms}"`
      : ""
    }
    ${!!payment.values.expectedAmount
      ? `expectedAmount: "${payment.values.expectedAmount}"`
      : ""
    }   
     ${!!receivedAmounts.length
      ? `receivedAmountTransaction: "${formattedReceivedAmounts.replace(
        /"/g,
        '\\"'
      )}"`
      : ""
    }
    ${!!totalReceivedAmount ? `receivedAmount: "${totalReceivedAmount}"` : ""}
    ${!!payment.values.transferFee
      ? `transferFee: "${payment.values.transferFee}"`
      : ""
    }
    ${!!payment.values.status ? `status: ${payment.values.status}` : ""}
   
    ${!!payment.values.typeOfPayment
      ? `typeOfPayment: "${payment.values.typeOfPayment}"`
      : ""
    }
    ${!!payment.values.officerCode
      ? `officerCode: "${formatGQLString(payment.values.officerCode)}"`
      : ""
    }
    ${!!payment.values.origin
      ? `origin: "${formatGQLString(payment.values.origin)}"`
      : ""
    }
    ${!!payment.values.rejectedReason
      ? `rejectedReason: "${formatGQLString(payment.values.rejectedReason)}"`
      : ""
    }
    ${!!payment.values.premium_uuid
      ? `premiumUuid: "${payment.values.premium_uuid}"`
      : ""
    }
  `;
}

export const updatePayment = (payment) => {
  return async (dispatch) => {
    dispatch(updatePaymentRequest());

    try {
      const mutationQuery = formatMutation(
        "updatePayment",
        formatPaymentGQL(payment),
        "updatePayment.mutationLabel"
      );

      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(updatePaymentSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(updatePaymentFailure(error.message));
    }
  };
};
// let contractId = `id: "${decodeId(contract.id)}"`;
export const submitContract = (userData) => {
  return async (dispatch) => {
    dispatch(submitContractRequest());
    try {
      const mutationQuery = formatMutation(
        "submitContract",
        `
        id: "${userData}"
       
        `,
        "submitContract.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(submitContractSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(submitContractFailure(error.message));
    }
  };
};

export const deleteContractDetail = (userData) => {
  return async (dispatch) => {
    dispatch(deleteContractDetailRequest());
    try {
      const mutationQuery = formatMutation(
        "deleteContractDetails",
        `
              uuids: ["${decodeId(userData)}"]
        `,
        "deleteContractDetails.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      dispatch(deleteContractDetailSuccess(data));
      dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(deleteContractDetailFailure(error.message));
    }
  };
};

export const validateUsername = (username, currentUsername = null) => {
  return async (dispatch) => {
    if (currentUsername === username) {
      return dispatch(fetchValidationSuccess(true));
    }

    dispatch(fetchValidationRequest());
    try {
      const query = gql`
          query ($username: String!) {
              isValid: validateUsername(username: $username)
          }
      `;
      const { data } = await client.query({
        query,
        variables: {
          username,
        },
      });
      dispatch(fetchValidationSuccess(data.isValid));
    } catch (error) {
      console.error("Error validating username:", error);
      dispatch(fetchValidationFailure(error.message));
    }
  };
};

function formatPolicyholderPrint(edited) {
  // console.log(edited, "format");
  let reportName = "registration_application";
  const formatPrint = `uuid: "${decodeId(
    edited
  )}",  isEmail: ${false},reportName: "${reportName}"`;
  return formatPrint;
}

export const printPolicyholderReport = (edited) => {
  return async (dispatch) => {
    dispatch(printPolicyholderRequest());
    try {
      const mutationQuery = `
      mutation SendNotification{
        sentNotification(${formatPolicyholderPrint(edited)}) {
        success
        message
        data
}}
      `;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(printPolicyholderSuccess(data));
        return data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(printPolicyholderFailure(error.message));
    }
  };
};

export const replacePolicyHolderContributionPlanBundle = (
  userData,
  contribution
) => {
  return async (dispatch) => {
    // dispatch(fetchDataRequest());
    try {
      const mutationQuery = `
      mutation {
        replacePolicyHolderContributionPlanBundle(
          input: {            
            uuid: "${decodeId(contribution.id)}"
          contributionPlanBundleId: "${decodeId(
        userData.contributionPlanBundle
      )}"
          dateValidFrom: "${dateTimeToDate(userData.dateValidFrom)}"
          }
        ) {
          clientMutationId
          internalId
        }
      }
      `;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      dispatch(fetchDataSuccess(data));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchDataFailure(error.message));
    }
  };
};

export const fetchVerifyByInsuree = (params) => {
  return async (dispatch) => {
    dispatch(fetchVerificationListRequest());
    try {
      console.log("======> fetchVerifyByInsuree params", params);
      const { data } = await client.query({
        query: gql`   {
            insurees(${params.join(" ")})
        {
            totalCount

            pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
            edges
            {
                node
                {
                    id,uuid,validityFrom,validityTo,chfId,otherNames,lastName,phone,email,photoUrl,age,gender{code},dob,marital,camuNumber,status,family{uuid,location{id, uuid, code, name, type, parent{id,uuid,code,name,type,parent{id,uuid,code,name,type,parent{id,uuid,code,name,type}}}}},currentVillage{id, uuid, code, name, type, parent{id,uuid,code,name,type,parent{id,uuid,code,name,type,parent{id,uuid,code,name,type}}}}
                }
            }
        }
        }

        `,
        fetchPolicy: "network-only",
      });
      console.log("======> fetchVerifyByInsuree data", data);
      if (data) {
        dispatch(fetchVerificationListSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data: fetchVerifyByInsuree", error);
      dispatch(fetchVerificationListFailure(error.message));
    }
  };
};

export const fetchVerificationHistory = (camuId, hfId) => {
  return async (dispatch) => {
    dispatch(fetchVerificationHistoryRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query GetVerificationHistory {
                getVerificationHistory(camuNumber:"${camuId}" ,hfId: "${hfId}"first: 5) {
                    totalCount
                    edgeCount
                    edges {
                        node {
                            id
                            uuid
                            tempCamuNumber
                            isVerified
                            camuNumber
                            claimInitiated
                            verificationCode
                            createdTime
                            userHf {
                                healthFacility {
                                    name
                                }
                                verifiedBy {
                                    id
                                    uuid
                                    chfId
                                    lastName
                                    otherNames
                                    age
                                    clientMutationId
                                    camuNumber
                                }
                            }
                            claimId
                            claimInsureeVerification {
                                totalCount
                                edgeCount
                                edges {
                                    node {
                                        id
                                        status
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchVerificationHistorySuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchVerificationHistoryFailure(error.message));
    }
  };
};

export const fetchPoliciesByInsuree = (camuId) => {
  return async (dispatch) => {
    dispatch(fetchPoliciesByInsureeRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                policiesByInsuree(
                    orderBy: "expiryDate"
                    activeOrLastExpiredOnly: true
                    chfId: "${camuId}"
                    first: 5
                ) {
                    totalCount

                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            policyUuid
                            productCode
                            productName
                            officerCode
                            officerName
                            enrollDate
                            effectiveDate
                            startDate
                            expiryDate
                            status
                            policyValue
                            balance
                            ded
                            dedInPatient
                            dedOutPatient
                            ceiling
                            ceilingInPatient
                            ceilingOutPatient
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchPoliciesByInsureeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPoliciesByInsureeFailure(error.message));
    }
  };
};

export const fetchLatestActiveInsureePolicy = (camuId) => {
  return async (dispatch) => {
    dispatch(fetchLatestActiveInsureePolicyRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query GetLatestActiveInsureePolicy {
                getLatestActiveInsureePolicy(chfId: "${camuId}") {
                    id
                    insuree {
                        uuid
                        chfId
                        lastName
                        otherNames
                        camuNumber
                        status
                    }
                    policy {
                        id
                        uuid
                        stage
                        status
                        value
                        enrollDate
                        startDate
                        effectiveDate
                        expiryDate
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchLatestActiveInsureePolicySuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchLatestActiveInsureePolicyFailure(error.message));
    }
  };
};

export function insureeVerificationHf(insureeId, hfId, guardianChfd) {
  const verifiedById = guardianChfd?.id
    ? `, verifiedBy: ${decodeId(guardianChfd.id)}`
    : "";
  let mutation = ``;
  return async (dispatch) => {
    // dispatch(fetchDataRequest());
    try {
      const mutationQuery = `
      mutation InsureeVerificationHf {
        insureeVerificationHf(hfId: ${hfId}, insureeId: ${decodeId(
        insureeId
      )} ${verifiedById}) {
            success
            message
            data {
              id
            }
        }
    }
      `;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      return data;
      // dispatch(fetchDataSuccess(data));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchDataFailure(error.message));
    }
  };
}

export const fetchGuardian = (camuId) => {
  return async (dispatch) => {
    dispatch(fetchGuardianRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query Insurees {
                insurees(chfId_Icontains: "${camuId}") {
                    totalCount
                    edgeCount
                    edges {
                        node {
                            firstGuardian {
                                id
                                lastName
                                otherNames
                                camuNumber
                                chfId
                            }
                            secondGuardian {
                                id
                                lastName
                                otherNames
                                camuNumber
                                chfId
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchGuardianSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchGuardianFailure(error.message));
    }
  };
};

export const fetchHealthFacilities = (id) => {
  return async (dispatch) => {
    dispatch(fetchHealthFacilityRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query HealthFacilities{
                healthFacilities(id: "${btoa(`HealthFacilityGQLType:${id}`)}") {
                    totalCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            id,
                            uuid,
                            code,
                            name,
                            level,
                            jsonExt,
                            fosaCode,
                            phone,
                            careType,
                            address,
                            phone
                            legalForm,
                            healthcarePackage {
                              id
                              uuid
                              label
                            }
                            healthcareProductBundle {
                              id
                              uuid
                              label
                            }
                            category {id,jsonExt,code,label,haveMedicalItem, haveMedicalAct, haveExamen,havePathology,verificationWithoutBiometry,serviceCategory {edges {node {id,name}}}}
                            servicesPricelist
                            { id,
                                uuid,name},
                            itemsPricelist
                            {id, uuid,name},
                            location{id,uuid,code,name,type, parent{id,uuid,code,name,type}}
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchHealthFacilitySuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchHealthFacilityFailure(error.message));
    }
  };
};

export const fetchHealthFacilitiesWithPackage = (id, params) => {
  return async (dispatch) => {
    dispatch(fetchHealthFacilitiesWithPackageRequest());
    try {
      // const healthFacilitiesArg = id
      //   ? `(id: "${btoa(`HealthFacilityGQLType:${id}`)}")`
      //   : "";
      const { data } = await client.query({
        query: gql`
            query HealthFacilitiesWithPackage {
              healthFacilities(uuid: "${id}") {
                edges {
                  node {
                    id
                    fosaLevel{
                      healthSupport
                    }
                    healthcarePackage {
                      id
                      label
                      actHealthcarePackageRelations(${params.join(" ,")}) {
                        totalCount      
                        pageInfo {        
                          hasNextPage        
                          hasPreviousPage        
                          startCursor        
                          endCursor      
                        }
                        edges {
                          cursor
                          node {
                            id
                            agreedPrice
                            isActive
                            actM2m {
                              id
                              uuid
                              label
                              fullCode
                              priceHomologated
                              apStatus
                              apThresholdType
                              apQuantityThreshold
                              apAmountThreshold
                              actType{
                                id
                                label
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchHealthFacilitiesWithPackageSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching health facilities with package:", error);
      dispatch(fetchHealthFacilitiesWithPackageFailure(error.message));
    }
  };
};

export const fetchHealthFacilitiesWithProductBundle = (id, params) => {
  return async (dispatch) => {
    dispatch(fetchHealthFacilitiesWithProductBundleRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query HealthFacilitiesWithProductBundle {
              healthFacilities(uuid: "${id}") {
                edges {
                  node {
                    id
                    fosaLevel{
                      healthSupport
                    }
                    healthcareProductBundle {
                      id
                      label
                      healthcareProductBundleProductRelations(${params.join(" ,")}) {
                        totalCount      
                        pageInfo {        
                          hasNextPage        
                          hasPreviousPage        
                          startCursor        
                          endCursor      
                        }
                        edges {
                          cursor
                          node {
                            id
                            agreedPrice
                            isActive
                            productM2m {
                              id
                              uuid
                              label
                              fullCode
                              priceHomologated
                              apStatus
                              apThresholdType
                              apQuantityThreshold
                              apAmountThreshold
                              productType{
                                id
                                label
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchHealthFacilitiesWithProductBundleSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching health facilities with product bundle:", error);
      dispatch(fetchHealthFacilitiesWithProductBundleFailure(error.message));
    }
  };
};

export const fetchConventionnementByHFId = (hfId) => {
  return async (dispatch) => {
    dispatch(fetchConventionnementByHFIdRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query ConventionnementByHf{
              conventionnementByHf(hfId: ${hfId}) {
                    totalCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                          id,
                          uuid,
                          name,
                          description,
                          signatureDate,
                          conventionNumber,
                          validityFrom,
                          validityTo,
                          status,
                          blockageReason
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchConventionnementByHFIdSuccess(data));
      }
    } catch (error) {
      console.log("====> try", error);
      console.error("Error fetching data:", error);
      dispatch(fetchConventionnementByHFIdFailure(error.message));
    }
  };
};

export const GetInsuresByHealthFacility = (hfUuid, params) => {
  if (!params) {
    return async (dispatch) => {
      dispatch(fetchInsureeHealthFacilityRequest());
      try {
        const { data } = await client.query({
          query: gql`
              query GetInsuresByHealthFacility {
                  getInsuresByHealthFacility(hfUuid: "${hfUuid}"){
                      totalCount
                      pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                      }
                      edges {
                          node {
                              id
                              uuid
                              chfId
                              policyholderinsureeSet {
                                edges {
                                    node {
                                      jsonExt
                                      policyHolder{code}
                                    }
                                }
                              }
                              lastName
                              otherNames
                              camuNumber
                              education {
                                  education
                                  id
                              }
                          }
                      }
                  }
              }
          `,
          fetchPolicy: "network-only",
        });
        if (data) {
          // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
          dispatch(fetchInsureeHealthFacilitySuccess(data));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(fetchInsureeHealthFacilityFailure(error.message));
      }
    };
  }

  return async (dispatch) => {
    dispatch(fetchInsureeHealthFacilityRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query GetInsuresByHealthFacility {
                getInsuresByHealthFacility(
                  ${params.join(" ,")}
                ){
                    totalCount
                    pageInfo {
                      hasNextPage
                      hasPreviousPage
                      startCursor
                      endCursor
                    }
                    edges {
                        node {
                            id
                            uuid
                            chfId
                            policyholderinsureeSet {
                              edges {
                                  node {
                                    jsonExt
                                    policyHolder{code}
                                  }
                              }
                            }
                            lastName
                            otherNames
                            camuNumber
                            education {
                                education
                                id
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchInsureeHealthFacilitySuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchInsureeHealthFacilityFailure(error.message));
    }
  };
};
export const GetInsuresStatusByHealthFacility = (hfUuid, InsureeUuid) => {
  return async (dispatch) => {
    dispatch(fetchStatusHealthFacilityRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query GetFosaStatus {
                getFosaStatus(hfUuid: "${hfUuid}", insureeUuid: "${InsureeUuid}") {
                    success
                    status
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchStatusHealthFacilitySuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchStatusHealthFacilityFailure(error.message));
    }
  };
};

export const GetSubstituteStatusByHealthFacility = (hfUuid, InsureeUuid) => {
  return async (dispatch) => {
    dispatch(fetchStatusHealthFacilitySubstituteRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query GetFosaStatus {
                getFosaStatus(hfUuid: "${hfUuid}", insureeUuid: "${InsureeUuid}") {
                    success
                    status
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchStatusHealthFacilitySubstituteSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchStatusHealthFacilitySubstituteFailure(error.message));
    }
  };
};

export const fetchVerificationCodes = (hfUuid, hfid) => {

  return async (dispatch) => {
    dispatch(fetchVerificationCodeRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query GetVerificationHistory{
                getVerificationHistory(camuNumber: "${hfUuid}",hfId:"${hfid}",claimInitiated: false,isVerified: true,) {
                    totalCount
                    edgeCount
                    edges {
                        node {
                            verificationCode
                            isClinicalVerification
                            id
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchVerificationCodeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchVerificationCodeFailure(error.message));
    }
  };
};

export const createValidationCodeWithoutBiometryMutation = async (payload) => {
  const mutationQuery = `
    mutation CreateValidationCodeWithoutBiometryMutation {
      createValidationCodeWithoutBiometry (
        clinicalVerificationCode: "${payload.clinicalVerificationCode}",
        insureeId: ${payload.insureeId},
        hfId: ${payload.hfId}
      ) {
          success
          message
      }
    }`;
  const { data } = await client.mutate({
    mutation: gql`
          ${mutationQuery}
      `,
  });

  return data?.createValidationCodeWithoutBiometry;
};

export const fetchConsultantHf = (hfUuid) => {
  return async (dispatch) => {
    dispatch(fetchConsultantHfRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query GetConsultantHfInsuree {
                getConsultantHfInsuree(
                    first: 10
                    orderBy: ["insuree"]
                    healthFacility_Uuid: ${hfUuid}
                ) {
                    totalCount
                    edgeCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            id
                            insuree {
                                camuNumber
                                lastName
                                otherNames
                            }
                            designation
                            speciality {
                                id
                                designation
                            }
                            position {
                                id
                                designation
                                isHealthProfessional
                            }
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchConsultantHfSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchConsultantHfFailure(error.message));
    }
  };
};

function formatprintCareSheet(edited) {
  console.log(edited, "format");
  const formatPrint = `camuNumber: "${edited?.camuNumber}",uniqueId: "${edited?.verificationCode}"`;
  return formatPrint;
}

export const printCareSheet = (edited) => {
  return async (dispatch) => {
    dispatch(printCareSheetRequest());
    try {
      const mutationQuery = `
      mutation CamuCareSheet{
        camuCareSheet(${formatprintCareSheet(edited)}) {
        success
        message
        data
}}
      `;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(printCareSheetSuccess(data));
        return data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(printCareSheetFailure(error.message));
    }
  };
};

export function formatFosaUserGQL(fosaData) {
  return `
    ${!!fosaData.userName ? `username: "${fosaData.userName}"` : ""}
    ${!!fosaData.password ? `password: "${fosaData.password}"` : ""}
    ${!!fosaData.email ? `email: "${fosaData.email}"` : ""}

    ${!!fosaData.permissions
      ? `permission: [${fosaData.permissions.map(
        (permission) => permission.value
      )}]`
      : ""
    }
    ${!!fosaData.insureeId ? `insureeId: "${decodeId(fosaData.insureeId)}"` : ""
    }
    ${!!fosaData.fosaId ? `fosaId: "${decodeId(fosaData.fosaId)}"` : ""}
    ${!!fosaData.phId ? `phId: "${fosaData.phId}"` : ""}
  
  `;
}

export const createFosaUser = (fosaData, params) => {
  console.log("createFosa", fosaData);
  return async (dispatch) => {
    dispatch(createFosaUserRequest());
    try {
      const mutationQuery = `mutation CreateFosaUser {
        createFosaUser(
            input: {
               ${formatFosaUserGQL(fosaData)}
            }
        ) {
            success
            message
        }
    }`;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      dispatch(createFosaUserSuccess(data));
      // dispatch(fetchMutation(mutationQuery.clientMutationId));
      dispatch(fetchMedicalStaffInsureeByFilter(params));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(createFosaUserFailure(error.message));
    }
  };
};
//   const mutation = formatMutation("deleteUser", `uuids: ["${decodeId(user.id)}"]`,  DO not delete

export const formUserGQL = (userData) => {
  let query = ``;
  for (const [key, value] of Object.entries(userData)) {
    if (["healthFacilityId"].includes(key)) {
      query += `${key}: ${value}, `;
    } else if (key === "roles" || key === "userTypes" || key === "districts") {
      query += `${key}: [${value.join(",")}],`;
    } else if (key === "insureeId") {
      query += `${key}: ${value},`;
    } else {
      if (value) {
        query += `${key}: "${value}",`;
      }
    }
  }

  return query;
};

export async function fetchMutation2(clientMutationId) {
  const payload = formatPageQuery(
    "mutationLogs",
    [`clientMutationId: "${clientMutationId}"`],
    [
      "id",
      "status",
      "error",
      "clientMutationId",
      "clientMutationLabel",
      "clientMutationDetails",
      "requestDateTime",
    ]
  );
  const { data } = await client.mutate({
    mutation: gql`
      ${payload}
    `,
  });
  return data;
}

export const createAdminUser = (payload) => {
  return async (dispatch) => {
    dispatch(createAdminRequest());
    try {
      const mutationQuery = `mutation createUser {
        createUser(
            input: {
               ${formUserGQL(payload)}
            }
        ) {
            clientMutationId
            internalId
        }
    }`;
      const { data } = await client.mutate({
        mutation: gql`
          ${mutationQuery}
        `,
      });

      const { mutationLogs } = await fetchMutation2(
        data?.createUser?.clientMutationId
      );

      if (mutationLogs?.edges?.[0]?.node?.error) {
        dispatch(
          createAdminFailure(
            "Une erreur s'est produite. Lors de la création de l'utilisateur. Assurez vous que le nom d'utilisateur et l'adresse email soient unique. et que la date de début de validité soit correcte."
          )
        );
      } else {
        dispatch(createAdminSuccess("Création de l'utilisateur réussie"));
      }
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(
        createAdminFailure(
          "Une erreur s'est produite. Lors de la création de l'utilisateur."
        )
      );
    }
  };
};

export const updateAdminUser = (payload) => {
  return async (dispatch) => {
    dispatch(editAdminRequest());
    try {
      const mutationQuery = `mutation updateUser {
        updateUser(
            input: {
               ${formUserGQL(payload)}
            }
        ) {
            clientMutationId
            internalId
        }
    }`;
      const { data } = await client.mutate({
        mutation: gql`
          ${mutationQuery}
        `,
      });

      const { mutationLogs } = await fetchMutation2(
        data?.updateUser?.clientMutationId
      );

      if (mutationLogs?.edges?.[0]?.node?.error) {
        dispatch(
          editAdminFailure(
            "Une erreur s'est produite. Lors de la mise à jour de l'utilisateur. Assurez vous que le nom d'utilisateur et l'adresse email soient unique. et Assurez vous que le mot de passe actuel soit correct."
          )
        );
      } else {
        dispatch(editAdminSuccess("Modification de l'utilisateur réussie"));
      }
    } catch (error) {
      console.error("Error update user:", error);
      dispatch(
        editAdminFailure(
          "Une erreur s'est produite. Lors de la mise à jour de l'utilisateur."
        )
      );
    }
  };
};

export const getAdminUsers = (params) => {
  return async (dispatch) => {
    dispatch(fetchAdminTableRequest());
    try {
      const { data } = await client.query({
        query: gql`
          query {
            users(
              ${params.join(" ,")}
            ) {
              totalCount
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
              }
              edges {
                node {
                  id
                  username
                  officer{id,dob,phone,lastName,otherNames,email,station{id,name}}
                  iUser{id,uuid,phone,lastName,otherNames,email,roles{id,name}, healthFacility{id, name}}
                  claimAdmin{id,phone,lastName,otherNames,emailId,dob}
                  clientMutationId
                }
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchAdminTableSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchAdminTableFailure(error.message));
    }
  };
};

const getAdminUserQuery = async (id) => {
  const { data } = await client.query({
    query: gql`
      query {
        users(id:"${id}") {
          edges {
            node {
              id
              username
              officer{id,dob,phone,lastName,otherNames,email,station{id,name}}
              iUser{
                id,phone,lastName,otherNames,email,roles{id,name}, 
                healthFacility{id, name}
                districts: userdistrictSet { location { id name code uuid parent { id code uuid name }}}
                roles { id name isSystem, uuid}
                insuree { id chfId lastName otherNames }
              }
              officer {
                id
                uuid
                hasLogin
                phone
                dob
                lastName
                otherNames
                address
                substitutionOfficer { id lastName otherNames code }
                worksTo
                officerVillages {
                  id
                  location {
                    id
                    name
                    code
                    uuid
                    parent {
                      id
                      name
                      code
                      uuid
                    }
                  }
                }
                location {
                  id
                  name
                  uuid
                  code
                  parent {
                    id
                    name
                    uuid
                    code
                  }
                }
              }
              claimAdmin{id,phone,lastName,otherNames,emailId,dob}
              clientMutationId
            }
          }
        }
      }
    `,
    fetchPolicy: "network-only",
  });

  return data;
};

export const getAdminUser = (id) => {
  return async (dispatch) => {
    dispatch(fetchAdminRequest());
    try {
      const data = await getAdminUserQuery(id);
      if (data) {
        dispatch(fetchAdminSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchAdminFailure(error.message));
    }
  };
};

export const getClaims = (
  params,
  Location_Parent_Uuid,
  Location_Uuid,
  healthFacility_Uuid
) => {
  return async (dispatch) => {
    dispatch(fetchClaimTableRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query Claims {
                claims(
                ${params.join(" ,")}
                ) {
                totalCount
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    node {
                        uuid
                        code
                        insureeVerification {
                            id
                            verificationCode
                        }
                        jsonExt
                        userSubmitClaim {
                            lastName
                            otherNames
                        }
                        dateClaimed
                        dateProcessed
                        feedbackStatus
                        reviewStatus
                        claimed
                        approved
                        status
                        invoice {
                            id
                            invoiceNumber
                        }
                        healthFacility {
                            id
                            uuid
                            name
                            code
                            jsonExt
                            fosaCode
                        }
                        insuree {
                            id
                            uuid
                            chfId
                            camuNumber
                            lastName
                            otherNames
                            jsonExt
                            status
                            gender {
                                code
                            }
                            age
                            family {
                                id
                                uuid
                                headInsuree {
                                    lastName
                                    otherNames
                                    chfId
                                    camuNumber
                                }
                            }
                            policyholderinsureeSet {
                                edges {
                                    node {
                                        policyHolder {
                                            tradeName
                                            code
                                        }
                                    }
                                }
                            }
                        }
                        attachmentsCount
                    }
                }
            }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchClaimTableSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchClaimTableFailure(error.message));
    }
  };
};

export const fetchInsureeClaimService = (serviceId, hfId, insureeId) => {
  return async (dispatch) => {
    dispatch(fetchInsureeClaimServiceRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query InsureeClaimService {
                insureeClaimService(ipId: ${decodeId(
          insureeId
        )}, fosaId: ${decodeId(hfId)}, pricelistId: ${decodeId(
          serviceId
        )}, first: 100) {
                    totalCount
                    edges {
                        node {
                            id
                            name
                            code
                            price
                            categoryType
                            jsonExt
                            requiredCondition
                            requiredQty
                            requiredFullAmt
                            requiredType
                        }
                    }
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchInsureeClaimServiceSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchInsureeClaimServiceFailure(error.message));
    }
  };
};
export const fetchInsureeItemService = (serviceId, hfId, insureeId) => {
  return async (dispatch) => {
    dispatch(fetchInsureeItemServiceRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query insureeItemServiceFosa  {
                insureeItemServiceFosa(ipId: ${decodeId(
          insureeId
        )}, fosaId: ${decodeId(hfId)}, pricelistId: ${decodeId(
          serviceId
        )}, first: 100) {
                    totalCount
                    edges {
                        node {
                            id
                            name
                            code
                            price
                            quantity
                            jsonExt
                            requiredCondition
                            requiredQty
                            requiredFullAmt
                            requiredType
                        }
                    }
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchInsureeItemServiceSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchInsureeItemServiceFailure(error.message));
    }
  };
};

export const fetchpathology = () => {
  return async (dispatch) => {
    dispatch(fetchPathologyRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query DiagnosisPicker($search: String) {
                diagnosesStr(str: $search, last: 38) {
                    edges {
                        node {
                            id
                            code
                            name
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        dispatch(fetchPathologySuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPathologyFailure(error.message));
    }
  };
};

export function formatAttachment(attach) {
  // ${!!attach.uuid ? `claimUuid: "${attach.uuid}"` : ""}
  return `
    ${!!attach.id ? `id: "${decodeId(attach.id)}"` : ""}
    ${!!attach.type ? `type: "${formatGQLString(attach.type)}"` : ""}
    ${!!attach.title ? `title: "${formatGQLString(attach.title)}"` : ""}
    ${!!attach.date ? `date: "${attach.date}"` : ""}
    ${!!attach.mime ? `mime: "${attach.mime}"` : ""}
    ${!!attach.filename ? `filename: "${formatGQLString(attach.filename)}"` : ""
    }
    ${!!attach.document ? `document: "${attach.document}"` : ""}
  `;
}

export function formatAttachmentforSelected(attach) {
  return `
    ${!!attach.id ? `id: "${decodeId(attach.id)}"` : ""}
    ${!!attach.uuid ? `claimUuid: "${attach.uuid}"` : ""}
    ${!!attach.type ? `type: "${formatGQLString(attach.type)}"` : ""}
    ${!!attach.title ? `title: "${formatGQLString(attach.title)}"` : ""}
    ${!!attach.date ? `date: "${attach.date}"` : ""}
    ${!!attach.mime ? `mime: "${attach.mime}"` : ""}
    ${!!attach.filename ? `filename: "${formatGQLString(attach.filename)}"` : ""
    }
    ${!!attach.document ? `document: "${attach.document}"` : ""}
  `;
}

export function formatAttachments(attachments) {
  return `[
    ${attachments
      .map(
        (a) => `{
      ${formatAttachment(a)}
    }`
      )
      .join("")}
  ]`;
}

export const createClaim = (payload) => {
  return async (dispatch) => {
    dispatch(createClaimRequest());

    try {
      let servicesField =
        payload.services && payload.services.length > 0
          ? `services: [${payload?.services
            ?.map(
              (service) => `
        {
          serviceId: ${service?.serviceId && service?.serviceId},
          priceAsked: "${service?.priceAsked && service?.priceAsked}",
          qtyProvided: "${service?.qtyProvided && service?.qtyProvided}",
          status: ${service?.status && service?.status},
          jsonExt: "${service?.jsonExt.replace(/"/g, '\\"')}"
        }`
            )
            .join(", ")}]`
          : "";

      // Backend ClaimProductsInputType (gql_mutations.py): health_product_id, status, qty_provided, price_asked, json_ext, explanation. No itemId.
      let claimProductsField =
        payload.claimProducts && payload.claimProducts.length > 0
          ? `claimProducts: [${payload.claimProducts?.filter(item => item?.healthProductId)
            .map(
              (item) => {
                const health_product_id = String(item?.healthProductId ?? item?.itemId ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const qty_provided = String(item?.qtyProvided ?? "").replace(/"/g, '\\"');
                const price_asked = String(item?.priceAsked ?? "").replace(/"/g, '\\"');
                const json_ext = (typeof item?.jsonExt === "string" ? item.jsonExt : JSON.stringify(item?.jsonExt || {})).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const explanation = String(item?.explanation ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                return `
        {
          healthProductId: "${health_product_id}",
          status: ${item?.status ?? 1},
          qtyProvided: "${qty_provided}",
          priceAsked: "${price_asked}",
          jsonExt: "${json_ext}"${explanation ? `,
          explanation: "${explanation}"` : ""}
        }`;
              }
            )
            .join(", ")}]`
          : "";

      // Backend ClaimActsInputType: act_id (required), status, qty_provided, price_asked, json_ext, explanation.
      let actsField =
        payload.acts && payload.acts.length > 0
          ? `acts: [${payload.acts?.filter(item => item?.actId)
            .map(
              (act) => {
                const act_id = String(act?.actId ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const qty_provided = String(act?.qtyProvided ?? act?.quantity ?? "").replace(/"/g, '\\"');
                const price_asked = String(act?.priceAsked ?? act?.price ?? "").replace(/"/g, '\\"');
                const json_ext = (typeof act?.jsonExt === "string" ? act.jsonExt : JSON.stringify(act?.jsonExt || {})).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const explanation = String(act?.explanation ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                return `
        {
          actId: "${act_id}",
          status: ${act?.status ?? 1},
          qtyProvided: "${qty_provided}",
          priceAsked: "${price_asked}",
          jsonExt: "${json_ext}"${explanation ? `,
          explanation: "${explanation}"` : ""}
        }`;
              }
            )
            .join(", ")}]`
          : "";

      let mutationQuery = formatMutation(
        "createClaim",
        `code:""
        insureeId : ${payload["insureeId"]},
        insureeVerificationId : ${payload["insureeVerification"]},
        ${payload["adminId"] ? `adminId: ${decodeId(payload["adminId"])}` : ""},
        dateFrom : "${dateTimeToDate(payload["dateFrom"])}",
        ${payload["dateTo"]
          ? `dateTo: "${dateTimeToDate(payload["dateTo"])}"`
          : ""
        }
        ${payload["icdId"] ? `icdId: ${decodeId(payload["icdId"])}` : ""}
        ${payload["icd1Id"] ? `icd1Id: ${decodeId(payload["icd1Id"])}` : ""}
        ${payload["icd2Id"] ? `icd2Id: ${decodeId(payload["icd2Id"])}` : ""}
        ${payload["icd3Id"] ? `icd3Id: ${decodeId(payload["icd3Id"])}` : ""}
        ${payload["icd4Id"] ? `icd4Id: ${decodeId(payload["icd4Id"])}` : ""}
        jsonExt : "${JSON.stringify(payload["jsonExt"]).replace(/"/g, '\\"')}",
        feedbackStatus : ${payload["feedbackStatus"]},
        reviewStatus : ${payload["reviewStatus"]},
        dateClaimed : "${dateTimeToDate(payload["dateClaimed"])}",
        healthFacilityId : ${payload["healthFacilityId"]},
        visitType :"${payload["visitType"] ? payload["visitType"] : ""}",
        ${servicesField}
        ${claimProductsField}
        ${actsField}
        ${payload["attachments"] && payload["attachments"].length
          ? `attachments: ${formatAttachments(payload["attachments"])}`
          : ""
        }


`,
        // ${payload['attacments'] && payload['attacments'].length
        // ? `attachments: ${formatAttachments(payload['attacments'])}`
        // : ""
        // }
        "createClaim.mutationLabel"
      );


      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      if (data) {
        dispatch(createClaimSuccess(data));
        dispatch(fetchMutation(mutationQuery.clientMutationId));
      }
    } catch (error) {
      console.error("=====> Error fetching data:", error);
      dispatch(createClaimFailure(error.message));
    }
  };
};

export const fetchClaimHistoryById = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchClaimHistoryByIdRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                claimHistory(uuid: "${uuid}")
                {
                    uuid,code,dateFrom,dateTo,validityFrom,validityTo,dateClaimed,claimed,approved,valuated,status,feedbackStatus,reviewStatus,guaranteeId,explanation,rejectionReason,rejectionComment, isFullRejected,reworkReason,requestPaymentComment,adjustment,attachmentsCount,
                    healthFacility{id, uuid, code, name, level, jsonExt, fosaCode, servicesPricelist{id, uuid}, itemsPricelist{id, uuid},
                        location{id,uuid,code,name,type, parent{id,uuid,code,name,type}}},
                    insuree{id, uuid, chfId, camuNumber, lastName, otherNames, jsonExt, status, gender{code}, age, family{id,uuid,headInsuree{lastName otherNames chfId camuNumber}}, policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}},visitType,adjuster{lastName, otherNames},admin{id, uuid, code, lastName, otherNames, healthFacility{id, uuid, code, name, level, servicesPricelist{id, uuid}, itemsPricelist{id, uuid}, location{id, uuid, code, name, parent{id, uuid, code, name}}}},icd{id, code, name},icd1{id, code, name},icd2{id, code, name},icd3{id, code, name},icd4{id, code, name},jsonExt,insureeVerification{id verificationCode},services{id, service {id code name price,categoryType} jsonExt,qtyProvided, priceAsked, qtyApproved, priceApproved, priceValuated, priceAdjusted, explanation, justification, rejectionReason, status},items{id, item {id code name price} jsonExt, qtyProvided, priceAsked, qtyApproved, priceApproved, priceValuated, priceAdjusted, explanation, justification, rejectionReason, status}
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchClaimHistoryByIdSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchClaimHistoryByIdFailure(error.message));
    }
  };
};

export const fetchClaimById = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchClaimByIdRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
              claim(uuid: "${uuid}") {
                  uuid
                  code
                  dateFrom
                  dateTo
                  dateClaimed
                  claimed
                  approved
                  valuated
                  status
                  feedbackStatus
                  reviewStatus
                  guaranteeId
                  explanation
                  rejectionReason
                  rejectionComment
                  isFullRejected
                  reworkReason
                  adjustment
                  attachmentsCount

                  healthFacility {
                    id
                    uuid
                    code
                    name
                    level
                    jsonExt
                    fosaCode
                    servicesPricelist {
                      id
                      uuid
                    }
                    itemsPricelist {
                      id
                      uuid
                    }
                    location {
                      id
                      uuid
                      code
                      name
                      type
                      parent {
                        id
                        uuid
                        code
                        name
                        type
                      }
                    }
                  }

                  insuree {
                    id
                    uuid
                    chfId
                    camuNumber
                    lastName
                    otherNames
                    jsonExt
                    status
                    gender {
                      code
                    }
                    age
                    family {
                      id
                      uuid
                      headInsuree {
                        lastName
                        otherNames
                        chfId
                        camuNumber
                      }
                    }
                    policyholderinsureeSet {
                      edges {
                        node {
                          policyHolder {
                            tradeName
                            code
                          }
                        }
                      }
                    }
                  }

                  visitType

                  admin {
                    id
                    uuid
                    code
                    lastName
                    otherNames
                    healthFacility {
                      id
                      uuid
                      code
                      name
                      level
                      servicesPricelist {
                        id
                        uuid
                      }
                      itemsPricelist {
                        id
                        uuid
                      }
                      location {
                        id
                        uuid
                        code
                        name
                        parent {
                          id
                          uuid
                          code
                          name
                        }
                      }
                    }
                  }

                  icd { id code name }
                  icd1 { id code name }
                  icd2 { id code name }
                  icd3 { id code name }
                  icd4 { id code name }

                  jsonExt

                  insureeVerification {
                    id
                    verificationCode
                  }

                  services {
                    id
                    service {
                      id
                      code
                      name
                      price
                      categoryType
                    }
                    jsonExt
                    qtyProvided
                    priceAsked
                    qtyApproved
                    priceApproved
                    priceValuated
                    priceAdjusted
                    explanation
                    justification
                    rejectionReason
                    status
                  }

                  items {
                    id
                    item {
                      id
                      code
                      name
                      price
                    }
                    jsonExt
                    qtyProvided
                    priceAsked
                    qtyApproved
                    priceApproved
                    priceValuated
                    priceAdjusted
                    explanation
                    justification
                    rejectionReason
                    status
                  }

                  acts {
                    id
                    act {
                      id
                      uuid
                      fullCode
                      label
                      priceHomologated
                      actType {
                        id
                        label
                      }
                    }
                    jsonExt
                    qtyProvided
                    priceAsked
                    qtyApproved
                    priceApproved
                    priceValuated
                    priceAdjusted
                    explanation
                    justification
                    rejectionReason
                    status
                  }

                  claimProducts {
                    id
                    healthProduct {
                      id
                      uuid
                      fullCode
                      label
                      priceHomologated
                    }
                    jsonExt
                    qtyProvided
                    priceAsked
                    qtyApproved
                    priceApproved
                    priceValuated
                    priceAdjusted
                    explanation
                    justification
                    rejectionReason
                    status
                  }
                }

            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchClaimByIdSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchClaimByIdFailure(error.message));
    }
  };
};

export const fetchRoles = () => {
  return async (dispatch) => {
    dispatch(fetchRolesRequest());
    try {
      const { data } = await client.query({
        query: gql`
          query UserRolesPicker {
            role {
              edges {
                node {
                  id
                  name
                  isSystem
                }
              }
            }
          }
        `,
      });
      if (data) {
        dispatch(fetchRolesSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchRolesFailure(error.message));
    }
  };
};

export const fetchAdminId = (id) => {
  return async (dispatch) => {
    dispatch(fetchAdminIdRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query Users {
                users(id: "${id}") {
                    edges {
                        node {
                            id
                            username
                            iUser{
                                roles{id}
                                isFosaEmp
                                fosaEmpPermissions
                            }
                            claimAdmin {
                                id
                                uuid
                                code
                                lastName
                                otherNames
                                healthFacility {
                                    id
                                    uuid
                                    code
                                    fosaCode
                                    name
                                    jsonExt
                                }
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchAdminIdSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchAdminIdFailure(error.message));
    }
  };
};

export const updateManagementStaff = (fosaData, insureeId, params) => {
  return async (dispatch) => {
    dispatch(createFosaUserRequest());
    try {
      const mutationQuery = `mutation UpdateDesignation {
        updateDesignation(
            designation: "${fosaData?.values?.positionId}"
            positionId: "${fosaData?.values?.positionId}"
            specialityId: "${fosaData?.values?.specialityId}"
            insureeId: "${decodeId(insureeId)}"
            policyHolderCode: "${fosaData?.code}"
            flag : true
        ) {
            success
            message
        }
    }`;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      if (data) {
        dispatch(createFosaUserSuccess(data));
        dispatch(fetchMedicalStaffInsureeByFilter(params));
      }
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(createFosaUserFailure(error.message));
    }
  };
};

export const GetConsultantHfInsuree = (params) => {
  return async (dispatch) => {
    dispatch(getConsultantHfInsureeRequest());
    try {
      const { data } = await client.query({
        query: gql`   {
            getConsultantHfInsuree(${params.join(" ")})
        {
            totalCount
            edgeCount
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            edges {
                node {
                    id
                    insuree {
                        camuNumber
                        lastName
                        otherNames
                        uuid
                        id
                        jsonExt
                    }
                    designation
                    speciality {
                        id
                        designation
                    }
                    position {
                        id
                        designation
                        isHealthProfessional
                    }
                }
            }
        }
        }

        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(getConsultantHfInsureeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(getConsultantHfInsureeFailure(error.message));
    }
  };
};

export const fetchMedicalStaffInsureeByFilter = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchMedicalStaffInsureeRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                policyHolderInsuree(${uuid})
            {
                totalCount

                pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                edges
                {
                    node
                    {
                        id,dateValidFrom,dateValidTo,employerNumber,jsonExt,lastPolicy{id},policyHolder{id}, user {
                        id
                        username
                        iUser{
                            roleId
                            roles{
                                id
                            }
                        }
                    },insuree{id, uuid, chfId, camuNumber, lastName, otherNames, jsonExt, status, gender{code}, age, family{id,uuid,headInsuree{lastName otherNames chfId camuNumber}}, policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}},contributionPlanBundle{id, code, name, periodicity, dateValidFrom, dateValidTo, isDeleted, replacementUuid},isDeleted,replacementUuid
                    }
                }
            }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchMedicalStaffInsureeSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchMedicalStaffInsureeFailure(error.message));
    }
  };
};

export const createNewConsultant = (data) => {
  console.log(data, "datay");
  return async (dispatch) => {
    dispatch(createFosaUserRequest());
    try {
      const mutationQuery = gql`
          mutation CreateHealthFacilityInsuree {
              createHealthFacilityInsuree(
                  hfId: ${data.hfId},
                  insureeId: ${data.insureeId},
                  insureeType: "${data.insuree_type}"
                  specialityId: ${decodeId(data.specialityId)}
                  positionId: ${decodeId(data.positionId)}
              ) {
                  success
                  message
              }
          }
      `;

      const { data: responseData } = await client.mutate({
        mutation: mutationQuery,
      });

      dispatch(createFosaUserSuccess(responseData));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(createFosaUserFailure(error.message));
    }
  };
};

export const updateConsultant = (data) => {
  console.log(data, "datay");
  return async (dispatch) => {
    dispatch(createFosaUserRequest());
    try {
      const mutationQuery = gql`
          mutation UpdateHealthFacilityInsuree {
              updateHealthFacilityInsuree(
                  id:${data.id}
                  specialityId: ${decodeId(data.specialityId)}
                  positionId: ${decodeId(data.positionId)}
              ) {
                  success
                  message
              }
          }
      `;

      const { data: responseData } = await client.mutate({
        mutation: mutationQuery,
      });

      dispatch(createFosaUserSuccess(responseData));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(createFosaUserFailure(error.message));
    }
  };
};

export const deleteConsultant = (id) => {
  return async (dispatch) => {
    dispatch(createFosaUserRequest());
    try {
      const mutationQuery = gql`
          mutation DeleteHealthFacilityInsuree {
              deleteHealthFacilityInsuree(
                  id:${id}
              ) {
                  success
                  message
              }
          }
      `;

      const { data: responseData } = await client.mutate({
        mutation: mutationQuery,
      });

      dispatch(createFosaUserSuccess(responseData));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(createFosaUserFailure(error.message));
    }
  };
};
export const updateFosaUser = (fosaData, params) => {
  return async (dispatch) => {
    dispatch(createFosaUserRequest());
    try {
      const userId = decodeId(fosaData?.userId);
      const permissions = fosaData?.values.permissions;
      const isDelete = permissions.length === 0;

      const mutationQuery = `mutation UpdateFosaUser {
  updateFosaUser(input: { 
    userId: "${userId}", 
    ${isDelete
          ? "isDelete: true"
          : `permission: [${permissions.map((permission) => permission.value)}]`
        }
  }) {
    success
    message
  }
}`;

      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      dispatch(createFosaUserSuccess(data));
      dispatch(fetchMedicalStaffInsureeByFilter(params));
      // dispatch(fetchMutation(mutationQuery.clientMutationId));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(createFosaUserFailure(error.message));
    }
  };
};

export const fetchFosaUser = (id) => {
  return async (dispatch) => {
    dispatch(fetchFosaUserRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query Users {
                users(id: "${id}") {
                    edges {
                        node {
                            id
                            username
                            iUser{
                                roles{id}
                                isFosaEmp
                                fosaEmpPermissions
                            }
                            claimAdmin {
                                id
                                uuid
                                code
                                lastName
                                otherNames
                                healthFacility {
                                    id
                                    uuid
                                    code
                                    fosaCode
                                    name
                                    jsonExt
                                }
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchFosaUserSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchFosaUserFailure(error.message));
    }
  };
};

export const fetchFosaMedicalItems = (fosaUuid, params) => {
  return async (dispatch) => {
    dispatch(fetchFosaMedicalItemsRequest());
    try {
      const { data } = !!params
        ? await client.query({
          query: gql`
            query MedicalItemsData {    
              medicalItemsData(
                ${params.join(" ,")}
              ) {
                totalCount      
                pageInfo {        
                  hasNextPage        
                  hasPreviousPage        
                  startCursor        
                  endCursor      
                }      
                edges {        
                  node {          
                    id          
                    uuid          
                    code          
                    name          
                    type                   
                    price                              
                  }      
                }   
              } 
            }
        `,
        })
        : await client.query({
          query: gql`
            query MedicalItemsData {    
              medicalItemsData(first: 20 priceListId: "${fosaUuid}") {
                totalCount      
                pageInfo {        
                  hasNextPage        
                  hasPreviousPage        
                  startCursor        
                  endCursor      
                }      
                edges {        
                  node {          
                    id          
                    uuid          
                    code          
                    name          
                    type                   
                    price                              
                  }      
                }   
              } 
            }
        `,
        });
      if (data) {
        dispatch(fetchFosaMedicalItemsSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchFosaMedicalItemsFailure(error.message));
    }
  };
};

export const fetchFosaMedicalServices = (fosaUuid, params) => {
  return async (dispatch) => {
    dispatch(fetchFosaMedicalServicesRequest());
    try {
      const { data } = !!params
        ? await client.query({
          query: gql`
            query MedicalServicesData {    
              medicalServicesData(
                ${params.join(" ,")}
              ) {
                totalCount      
                pageInfo {        
                  hasNextPage        
                  hasPreviousPage        
                  startCursor        
                  endCursor      
                }      
                edges {        
                  node {          
                    id          
                    uuid          
                    code          
                    name           
                    type                 
                    price                              
                  }      
                }   
              } 
            }
        `,
        })
        : await client.query({
          query: gql`
            query MedicalServicesData {    
              medicalServicesData(first: 20 priceListId: "${fosaUuid}") {
                totalCount      
                pageInfo {        
                  hasNextPage        
                  hasPreviousPage        
                  startCursor        
                  endCursor      
                }      
                edges {        
                  node {          
                    id          
                    uuid          
                    code          
                    name           
                    type                 
                    price                              
                  }      
                }   
              } 
            }
        `,
        });
      if (data) {
        dispatch(fetchFosaMedicalServicesSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchFosaMedicalServicesFailure(error.message));
    }
  };
};

export const fetchInsureeByUuid = (name) => {
  return async (dispatch) => {
    dispatch(fetchInsureeByUuidRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                insurees(uuid:"${name}", ignoreLocation:true)
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,uuid,chfId,lastName,otherNames,dob,age,validityFrom,validityTo,gender{code},family{id,uuid,headInsuree{
                            lastName
                            otherNames
                            chfId
                            camuNumber
                        }},photo{folder,filename,photo},gender{code, gender, altLanguage},photoUrl,camuNumber,status,statusComment,biometricsStatus,biometricsIsMaster,healthFacility{id, uuid, code, name, level, jsonExt, fosaCode, servicesPricelist{id, uuid}, itemsPricelist{id, uuid}, location{id,uuid,code,name,type, parent{id,uuid,code,name,type}}},jsonExt,createdBy,policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchInsureeByUuidSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchInsureeByUuidFailure(error.message));
    }
  };
};

export const fetchSubstitute = (name) => {
  return async (dispatch) => {
    dispatch(fetchSubstituteRequest());
    try {
      const { data } = await client.query({
        query: gql`
            {
                insurees(uuid:"${name}", ignoreLocation:true)
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,uuid,chfId,lastName,otherNames,dob,age,validityFrom,validityTo,gender{code},family{id,uuid,headInsuree{
                            lastName
                            otherNames
                            chfId
                            camuNumber
                        }},photo{folder,filename,photo},gender{code, gender, altLanguage},photoUrl,camuNumber,status,statusComment,biometricsStatus,biometricsIsMaster,healthFacility{id, uuid, code, name, level, jsonExt, fosaCode, servicesPricelist{id, uuid}, itemsPricelist{id, uuid}, location{id,uuid,code,name,type, parent{id,uuid,code,name,type}}},jsonExt,createdBy,policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}
                        }
                    }
                }
            }
        `,
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchSubstituteSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchSubstituteFailure(error.message));
    }
  };
};

/**
 * Submits a claim mutation request.
 *
 * @param {string | Array.<string>} claims - A single claim UUID or an array of claim UUIDs to submit.
 * @param invoiceNumber
 * @param note
 */
export async function generateInvoice(claims, invoiceNumber = null, note = "") {
  // Ensure claims is always treated as an array
  const claimsArray = Array.isArray(claims) ? claims : [claims];

  const GENERATE_INVOICE_MUTATION = gql`
      mutation GenerateInvoice(
          $claims: [String!]
          $invoiceNumber: String
          $note: String!
      ) {
          generateInvoice(
              claims: $claims
              invoiceNumber: $invoiceNumber
              note: $note
          ) {
              success
              message
              invoice {
                  id
              }
          }
      }
  `;

  const { data } = await client.mutate({
    mutation: GENERATE_INVOICE_MUTATION,
    variables: {
      claims: claimsArray,
      invoiceNumber, // Null will be sent if no invoiceNumber
      note, // Can be an empty string
    },
  });

  if (data.generateInvoice.success) {
    return {
      success: true,
      data: data.generateInvoice,
    };
  } else {
    return {
      success: false,
      data: data.generateInvoice.message,
    };
  }
}

/**
 * Submits a claim mutation request.
 *
 * @param {string | Array.<string>} payload - A single claim UUID or an array of claim UUIDs to submit.
 * @returns {Function} A thunk function that performs the mutation and dispatches actions based on the result.
 */
export const submitClaim = (payload) => {
  return async (dispatch) => {
    dispatch(submitClaimRequest());

    // Ensure payload is always treated as an array
    const payloadArray = Array.isArray(payload) ? payload : [payload];

    try {
      let mutationQuery = formatMutation(
        "submitClaims",
        `
        uuids: ${JSON.stringify(payloadArray)}
        `,
        "submitClaims.mutationLabel"
      );
      console.log("mutationQuery", mutationQuery.payload);
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      if (data) {
        console.log(data);
        dispatch(submitClaimSuccess(data));
        dispatch(fetchMutation(mutationQuery.clientMutationId));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(submitClaimFailure(error.message));
    }
  };
};

export const updateClaim = (payload) => {
  return async (dispatch) => {
    dispatch(updateClaimRequest());
    try {
      let servicesField =
        payload.services && payload.services.length > 0
          ? `services: [${payload?.services
            ?.map(
              (service) => `
        {
          serviceId: ${service?.serviceId && service?.serviceId},
          priceAsked: "${service?.priceAsked && service?.priceAsked}",
          qtyProvided: "${service?.qtyProvided && service?.qtyProvided}",
          status: ${service?.status && service?.status},
          jsonExt: "${service?.jsonExt.replace(/"/g, '\\"')}"
        }`
            )
            .join(", ")}]`
          : "";

      // Backend ClaimProductsInputType: health_product_id, status, qty_provided, price_asked, json_ext, explanation.
      let claimProductsField =
        payload.claimProducts && payload.claimProducts.length > 0
          ? `claimProducts: [${payload.claimProducts?.filter(item => item?.healthProductId)
            .map(
              (item) => {
                const health_product_id = String(item?.healthProductId ?? item?.itemId ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const qty_provided = String(item?.qtyProvided ?? "").replace(/"/g, '\\"');
                const price_asked = String(item?.priceAsked ?? "").replace(/"/g, '\\"');
                const json_ext = (typeof item?.jsonExt === "string" ? item.jsonExt : JSON.stringify(item?.jsonExt || {})).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const explanation = String(item?.explanation ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                return `
        {
          healthProductId: "${health_product_id}",
          status: ${item?.status ?? 1},
          qtyProvided: "${qty_provided}",
          priceAsked: "${price_asked}",
          jsonExt: "${json_ext}"${explanation ? `,
          explanation: "${explanation}"` : ""}
        }`;
              }
            )
            .join(", ")}]`
          : "";

      // Backend ClaimActsInputType: act_id (required), status, qty_provided, price_asked, json_ext, explanation.
      let actsField =
        payload.acts && payload.acts.length > 0
          ? `acts: [${payload.acts?.filter(item => item?.actId)
            .map(
              (act) => {
                const act_id = String(act?.actId ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const qty_provided = String(act?.qtyProvided ?? act?.quantity ?? "").replace(/"/g, '\\"');
                const price_asked = String(act?.priceAsked ?? act?.price ?? "").replace(/"/g, '\\"');
                const json_ext = (typeof act?.jsonExt === "string" ? act.jsonExt : JSON.stringify(act?.jsonExt || {})).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                const explanation = String(act?.explanation ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                return `
        {
          actId: "${act_id}",
          status: ${act?.status ?? 1},
          qtyProvided: "${qty_provided}",
          priceAsked: "${price_asked}",
          jsonExt: "${json_ext}"${explanation ? `,
          explanation: "${explanation}"` : ""}
        }`;
              }
            )
            .join(", ")}]`
          : "";

      let mutationQuery = formatMutation(
        "updateClaim",
        `code:"${payload["code"] ? payload["code"] : ""}"
        ${payload["uuid"] !== undefined && payload["uuid"] !== null
          ? `uuid: "${payload["uuid"]}"`
          : ""
        }
        insureeId : ${payload["insureeId"]},
        insureeVerificationId : ${payload["insureeVerification"]},
        ${payload["adminId"] ? `adminId: ${decodeId(payload["adminId"])}` : ""},
        dateFrom : "${dateTimeToDate(payload["dateFrom"])}",
        ${payload["dateTo"]
          ? `dateTo: "${dateTimeToDate(payload["dateTo"])}"`
          : ""
        }
        ${payload["icd"] ? `icdId: ${decodeId(payload["icd"])}` : ""}
        ${payload["icd1Id"] ? `icd1Id: ${decodeId(payload["icd1Id"])}` : ""}
        ${payload["icd2Id"] ? `icd2Id: ${decodeId(payload["icd2Id"])}` : ""}
        ${payload["icd3Id"] ? `icd3Id: ${decodeId(payload["icd3Id"])}` : ""}
        ${payload["icd4Id"] ? `icd4Id: ${decodeId(payload["icd4Id"])}` : ""}
        jsonExt : "${JSON.stringify(payload["jsonExt"]).replace(/"/g, '\\"')}",
        feedbackStatus : ${payload["feedbackStatus"]},
        reviewStatus : ${payload["reviewStatus"]},
        dateClaimed : "${dateTimeToDate(payload["dateClaimed"])}",
        healthFacilityId : ${payload["healthFacilityId"]},
        visitType :"${payload["visitType"] ? payload["visitType"] : ""}",
        ${servicesField}
        ${claimProductsField}
        ${actsField}
        ${payload["attachments"] && payload["attachments"].length
          ? `attachments: ${formatAttachments(payload["attachments"])}`
          : ""
        }
   
`,
        // ${payload['attachments'] && payload['attachments'].length
        // ? `attachments: ${formatAttachments(payload['attachments'])}`
        // : ""}
        "updateClaim.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      if (data) {
        dispatch(updateClaimSuccess(data));
        dispatch(fetchMutation(mutationQuery.clientMutationId));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(updateClaimFailure(error.message));
    }
  };
};

export const createAttachment = (payload) => {
  return async (dispatch) => {
    dispatch(createAttachmentRequest());
    try {
      let mutationQuery = formatMutation(
        "createClaimAttachment",
        `
         ${payload ? formatAttachmentforSelected(payload?.[0]) : ""}
`,
        "createClaimAttachment.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      if (data) {
        dispatch(createAttachmentSuccess(data));
        dispatch(fetchMutation(mutationQuery.clientMutationId));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(createAttachmentFailure(error.message));
    }
  };
};

export const fetchAttachments = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchAttachmentsRequest());
    try {
      const { data } = await client.query({
        query: gql`

            {
                claimAttachments(claim_Uuid: "${uuid}")
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,type,title,date,filename,mime
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchAttachmentsSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchAttachmentsFailure(error.message));
    }
  };
};

export const deleteClaimAttachment = (payload) => {
  return async (dispatch) => {
    dispatch(createAttachmentRequest());
    try {
      let mutationQuery = formatMutation(
        "deleteClaimAttachment",
        `
        id: "${payload}"
`,
        "deleteClaimAttachment.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      if (data) {
        dispatch(createAttachmentSuccess(data));
        dispatch(fetchMutation(mutationQuery.clientMutationId));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(createAttachmentFailure(error.message));
    }
  };
};

export const getPreAuthTableData = (params) => {
  return async (dispatch) => {
    dispatch(fetchPreAuthTableRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query PreAuthorizations {
                preAuthorizations(
                ${params.join(" ,")}
                ) {
                totalCount
                edgeCount
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    cursor
                    node {
                        id
                        isDeleted
                        userCreated {
                            id
                            username}
                        userUpdated {
                            id
                            username}
                        jsonExt
                        dateCreated
                        dateUpdated
                        version
                        code
                        comments
                        status
                        grandTotal
                        tmTotal
                        isDocuments
                        isSubmitted
                        isApproved
                        isRework
                        isRejected
                        rejectionReason
                        reworkReason
                        insuree {
                            id,
                            uuid
                            chfId
                            lastName
                            otherNames
                            dob
                            age
                            validityFrom
                            validityTo
                            gender{code}
                            family{id,uuid,headInsuree{
                                lastName
                                otherNames
                                chfId
                                camuNumber
                            }}
                            photo{folder,filename,photo}
                            gender{code, gender, altLanguage}
                            photoUrl
                            camuNumber
                            status
                            statusComment
                            biometricsStatus
                            biometricsIsMaster
                            jsonExt
                            createdBy
                            policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}
                        }
                        paActs {
                              id
                              status
                              qtyProvided
                              priceAsked
                              act {
                                id
                                uuid
                                code
                                fullCode
                                label
                                actType{
                                  id
                                  label
                                }
                                priceHomologated
                              }
                              jsonExt
                            }
                          paProducts {
                                id
                                status
                                qtyProvided
                                priceAsked
                                healthProduct{
                                  id
                                  uuid
                                  code
                                  fullCode
                                  label
                                  priceHomologated
                                  productType{
                                    id
                                    label
                                  }
                                }
                                jsonExt
                              }
                        healthFacility {
                            validityFrom
                            validityTo
                            legacyId
                            jsonExt
                            id
                            uuid
                            code
                            fosaCode
                            name
                            accCode
                            legalForm
                            level
                            address
                            phone
                            fax
                            email
                            careType
                            offline
                            auditUserId
                            clientMutationId
                        }
                        insureeVerification {
                            id
                            uuid
                            score
                            isVerified
                            loginName
                            tempCamuNumber
                            camuNumber
                            uniqueCode
                            createdBy
                            modifiedBy
                            createdTime
                            modifiedTime
                            status
                            jsonExt
                            verificationCode
                            claimId
                            claimInitiated
                        }
                    }
                }
            }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        dispatch(fetchPreAuthTableSuccess(data));
        // dispatch(GetPreauthDataSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPreAuthTableFailure(error.message));
    }
  };
};

export const getPreAuthDataById = (uuid) => {
  console.log(uuid);
  return async (dispatch) => {
    dispatch(fetchPreauthFormDataRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query PreAuthorizations {
                preAuthorizations(id:"${uuid}") {
                    totalCount
                    edgeCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        cursor
                        node {
                            id
                            isDeleted
                            jsonExt
                            dateCreated
                            dateUpdated
                            version
                            code
                            comments
                            status
                            grandTotal
                            tmTotal
                            isDocuments
                            isSubmitted
                            isApproved
                            isRework
                            isRejected
                            rejectionReason
                            reworkReason
                            insuree {
                                id,
                                uuid
                                chfId
                                lastName
                                otherNames
                                dob
                                age
                                validityFrom
                                validityTo
                                gender{code}
                                family{id,uuid,headInsuree{
                                    lastName
                                    otherNames
                                    chfId
                                    camuNumber
                                }}
                                photo{folder,filename,photo}
                                gender{code, gender, altLanguage}
                                photoUrl
                                camuNumber
                                status
                                statusComment
                                biometricsStatus
                                biometricsIsMaster
                                jsonExt
                                createdBy
                                policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}
                            }
                            healthFacility {
                                validityFrom
                                validityTo
                                legacyId
                                jsonExt
                                id
                                uuid
                                code
                                fosaCode
                                name
                                accCode
                                legalForm
                                level
                                address
                                phone
                                fax
                                email
                                careType
                                offline
                                auditUserId
                                clientMutationId
                            }
                            insureeVerification {
                                id
                                uuid
                                score
                                isVerified
                                loginName
                                tempCamuNumber
                                camuNumber
                                uniqueCode
                                createdBy
                                modifiedBy
                                createdTime
                                modifiedTime
                                status
                                jsonExt
                                verificationCode
                                claimId
                                claimInitiated
                            }
                            paActs {
                              id
                              status
                              qtyProvided
                              priceAsked
                              act {
                                id
                                uuid
                                code
                                fullCode
                                label
                                actType{
                                  id
                                  label
                                }
                                priceHomologated
                              }
                              jsonExt
                            }
                            paProducts {
                                id
                                status
                                qtyProvided
                                priceAsked
                                healthProduct{
                                  id
                                  uuid
                                  code
                                  fullCode
                                  label
                                  priceHomologated
                                  productType{
                                    id
                                    label
                                  }
                                }
                                jsonExt
                              }
                            services {
                                id
                                status
                                qtyProvided
                                priceAsked
                                service {
                                    id
                                    code
                                    name
                                    type
                                    categoryType
                                    price

                                }
                                jsonExt
                            }
                            items {
                                id
                                status
                                qtyProvided
                                priceAsked
                                item {
                                    id
                                    code
                                    name
                                    type
                                    price

                                }
                                jsonExt
                            }
                        }
                    }
                }
            }

        `,
        fetchPolicy: "network-only",
      });
      console.log(data, "preAuthFormData");
      if (data) {
        dispatch(fetchPreauthFormDataSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPreauthFormDataFailure(error.message));
    }
  };
};

export const SavePreAuthorization = (payload) => {
  return async (dispatch) => {
    dispatch(createPreAuthRequest());
    let servicesField =
      payload.services && payload.services.length > 0
        ? `services: [${payload?.services
          ?.map(
            (service) => `
    {
      serviceId: ${service?.serviceId && service?.serviceId},
      priceAsked: "${service?.priceAsked && service?.priceAsked}",
      qtyProvided: "${service?.qtyProvided && service?.qtyProvided}",
      status: ${service?.status && service?.status},
      jsonExt: "${service?.jsonExt.replace(/"/g, '\\"')}"
    }`
          )
          .join(", ")}]`
        : "";

    let itemsField =
      payload.items && payload.items.length > 0
        ? `items: [${payload.items
          .map(
            (item) => `
    {
      itemId: ${item?.itemId && item?.itemId},
      qtyProvided: "${item?.qtyProvided && item?.qtyProvided}",
      priceAsked: "${item?.priceAsked && item?.priceAsked}",
      status: ${item?.status && item?.status},
      jsonExt: "${item?.jsonExt.replace(/"/g, '\\"')}"
    }`
          )
          .join(", ")}]`
        : "";
    try {
      let mutationQuery = `
        mutation SavePreAuthorization {
          savePreAuthorization(
            insureeId: ${payload.insureeId},
            comments: "${payload.comments}",
            healthFacilityId: ${payload.healthFacilityId},
            insureeVerificationId:${payload.insureeVerificationId},
            jsonExt : "${JSON.stringify(payload["jsonExt"]).replace(
        /"/g,
        '\\"'
      )}",
            ${servicesField}
            ${itemsField}
                ${payload["attachments"] && payload["attachments"].length
          ? `reqAttachments: ${formatAttachments(
            payload["attachments"]
          )}`
          : ""
        }
          ) {
            success
            message
          }
        }
      `;

      console.log("mutationQuery", mutationQuery);

      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });

      if (data) {
        dispatch(createPreAuthSuccess(data.savePreAuthorization));
        dispatch(fetchMutation(mutationQuery.clientMutationId)); // Uncomment this line if `fetchMutation` is a valid action
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(createPreAuthFailure(error.message));
    }
  };
};

export const fetchAttachmentsPreAuth = (uuid) => {
  return async (dispatch) => {
    dispatch(fetchAttachmentsRequest());
    try {
      const { data } = await client.query({
        query: gql`

            {
                claimAttachments(preAuth_Id: "${uuid}")
                {

                    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
                    edges
                    {
                        node
                        {
                            id,type,title,date,filename,mime
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchAttachmentsSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchAttachmentsFailure(error.message));
    }
  };
};

export const deleteAttachmentPreAuth = (payload) => {
  return async (dispatch) => {
    dispatch(createAttachmentRequest());
    try {
      let mutationQuery = formatMutation(
        "deleteClaimAttachment",
        `
        id: "${payload}"
`,
        "deleteClaimAttachment.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });
      if (data) {
        dispatch(createAttachmentSuccess(data));
        dispatch(fetchMutation(mutationQuery.clientMutationId));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(createAttachmentFailure(error.message));
    }
  };
};

export const createAttachmentPreAuth = (payload) => {
  console.log(payload, "yy");
  return async (dispatch) => {
    dispatch(createAttachmentRequest());
    try {
      let mutationQuery = formatMutation(
        "createClaimAttachment",
        `
         ${payload ? formatAttachmentforPreauth(payload?.[0]) : ""}
`,
        "createClaimAttachment.mutationLabel"
      );
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery.payload}
        `,
      });

      console.log(mutationQuery, "mutationQuery");
      if (data) {
        dispatch(createAttachmentSuccess(data));
        dispatch(fetchMutation(mutationQuery.clientMutationId));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(createAttachmentFailure(error.message));
    }
  };
};

export function formatAttachmentforPreauth(attach) {
  return `
    ${!!attach.uuid ? `preAuthId: "${decodeId(attach.uuid)}"` : ""}
    ${!!attach.type ? `type: "${formatGQLString(attach.type)}"` : ""}
    ${!!attach.title ? `title: "${formatGQLString(attach.title)}"` : ""}
    ${!!attach.date ? `date: "${attach.date}"` : ""}
    ${!!attach.mime ? `mime: "${attach.mime}"` : ""}
    ${!!attach.filename ? `filename: "${formatGQLString(attach.filename)}"` : ""
    }
    ${!!attach.document ? `document: "${attach.document}"` : ""}
  `;
}

export const submitApproval = async (uuid) => {
  let mutationQuery = `
      mutation SavePreAuthorization {
        savePreAuthorization(
          id:"${uuid}"
          isSubmitted: true,
    ) {
          success
          message
        }
      }
    `;

  const { data } = await client.mutate({
    mutation: gql`
          ${mutationQuery}
      `,
  });

  return data;
};

export const savePreAuth = async (payload) => {
  let servicesField =
    payload.services && payload.services.length > 0
      ? `paActs: [${payload?.services
        ?.map(
          (service) => `
              {
                actId: "${service?.serviceId}",
                priceAsked: "${service?.priceAsked && service?.priceAsked}",
                qtyProvided: "${service?.qtyProvided && service?.qtyProvided}",
                status: ${service?.status && service?.status},
                jsonExt: "${service?.jsonExt.replace(/"/g, '\\"')}"
              }`
        )
        .join(", ")}]`
      : "";

  let itemsField =
    payload.items && payload.items.length > 0
      ? `paProducts: [${payload.items
        .map(
          (item) => `
                {
                  healthProductId: "${item?.itemId}",
                  qtyProvided: "${item?.qtyProvided && item?.qtyProvided}",
                  priceAsked: "${item?.priceAsked && item?.priceAsked}",
                  status: ${item?.status && item?.status},
                  jsonExt: "${item?.jsonExt.replace(/"/g, '\\"')}"
                }`
        )
        .join(", ")}]`
      : "";

  const idParam = payload.uuid !== undefined ? `id: "${payload.uuid}"` : "";

  let mutationQuery = `
        mutation SavePreAuthorization {
          savePreAuthorization(
            ${idParam}
            insureeId: ${payload.insureeId},
            insureeVerificationId: ${payload.insureeVerificationId},
            comments: "${payload.comments}",
            healthFacilityId: ${payload.healthFacilityId},
            jsonExt : "${JSON.stringify(payload["jsonExt"]).replace(
    /"/g,
    '\\"'
  )}",
            ${servicesField}
            ${itemsField}
                ${payload["attachments"] && payload["attachments"].length
      ? `reqAttachments: ${formatAttachments(
        payload["attachments"]
      )}`
      : ""
    }
          ) {
            success
            message
          }
        }
      `;

  const { data } = await client.mutate({
    mutation: gql`
            ${mutationQuery}
        `,
  });

  return data.savePreAuthorization;
};

export const updatePreAuth = (payload) => {
  return async (dispatch) => {
    // dispatch(createClaimRequest());
    let servicesField =
      payload.services && payload.services.length > 0
        ? `services: [${payload?.services
          ?.map(
            (service) => `
              {
                serviceId: ${service?.serviceId && service?.serviceId},
                priceAsked: "${service?.priceAsked && service?.priceAsked}",
                qtyProvided: "${service?.qtyProvided && service?.qtyProvided}",
                status: ${service?.status && service?.status},
                jsonExt: "${service?.jsonExt.replace(/"/g, '\\"')}"
              }`
          )
          .join(", ")}]`
        : "";

    let itemsField =
      payload.items && payload.items.length > 0
        ? `items: [${payload.items
          .map(
            (item) => `
                {
                  itemId: ${item?.itemId && item?.itemId},
                  qtyProvided: "${item?.qtyProvided && item?.qtyProvided}",
                  priceAsked: "${item?.priceAsked && item?.priceAsked}",
                  status: ${item?.status && item?.status},
                  jsonExt: "${item?.jsonExt.replace(/"/g, '\\"')}"
                }`
          )
          .join(", ")}]`
        : "";

    try {
      let mutationQuery = `
        mutation SavePreAuthorization {
          savePreAuthorization(
            id:"${payload.uuid}"
            insureeId: ${payload.insureeId},
            insureeVerification: "${payload.insureeVerification}",
            comments: "${payload.comments}",
            healthFacilityId: ${payload.healthFacilityId},
            jsonExt : "${JSON.stringify(payload["jsonExt"]).replace(
        /"/g,
        '\\"'
      )}",
            ${servicesField}
            ${itemsField}
                ${payload["attachments"] && payload["attachments"].length
          ? `reqAttachments: ${formatAttachments(
            payload["attachments"]
          )}`
          : ""
        }
          ) {
            success
            message
          }
        }
      `;

      console.log("mutationQuery", mutationQuery);

      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });

      if (data) {
        // dispatch(createClaimSuccess(data.savePreAuthorization));
        // dispatch(fetchMutation(mutationQuery.clientMutationId)); // Uncomment this line if `fetchMutation` is a valid action
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(createClaimFailure(error.message));
    }
  };
};

export const getPreAuthHistory = (uuid) => {
  console.log(uuid, "heyy");
  return async (dispatch) => {
    dispatch(fetchPreauthHistoryRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query PreAuthorizationsHistory {
                preAuthorizationsHistory(legacyId_Id:"${uuid}" first: 5) {
                    totalCount
                    edgeCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            code
                            comments
                            status
                            dateCreated
                            userCreated {
                                id
                                username}
                            userUpdated {
                                id
                                username}
                            dateUpdated
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      });

      if (data) {
        dispatch(fetchPreauthHistorySucess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchPreauthHistoryFailure(error.message));
    }
  };
};

export const getPreauthData = (uuid, VerificationId) => {
  return async (dispatch) => {
    dispatch(GetPreauthDataRequest());
    try {
      const { data } = await client.query({
        query: gql`
            query PreAuthorizations {
                preAuthorizations(insureeVerification_VerificationCode:"${VerificationId}",insureeVerification_CamuNumber:"${uuid}") {
                    totalCount
                    edgeCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        cursor
                        node {
                            id
                            insuree {
                                id,
                                uuid
                                chfId
                                lastName
                                otherNames
                                dob
                                age
                                validityFrom
                                validityTo
                                gender{code}
                                family{id,uuid,headInsuree{
                                    lastName
                                    otherNames
                                    chfId
                                    camuNumber
                                }}
                                photo{folder,filename,photo}
                                gender{code, gender, altLanguage}
                                photoUrl
                                camuNumber
                                status
                                statusComment
                                biometricsStatus
                                biometricsIsMaster
                                jsonExt
                                createdBy
                                policyholderinsureeSet {edges{node{policyHolder{tradeName,code}}}}
                            }
                            jsonExt
                            healthFacility {
                                validityFrom
                                validityTo
                                legacyId
                                jsonExt
                                id
                                uuid
                                code
                                fosaCode
                                name
                                accCode
                                legalForm
                                level
                                address
                                phone
                                fax
                                email
                                careType
                                offline
                                auditUserId
                                clientMutationId
                                servicesPricelist{id, uuid}
                                itemsPricelist{id, uuid}
                            }
                            paActs {
                              id
                              status
                              qtyProvided
                              priceAsked
                              act {
                                id
                                uuid
                                code
                                fullCode
                                label
                                actType{
                                  id
                                  label
                                }
                                priceHomologated
                              }
                              jsonExt
                            }
                            paProducts {
                                id
                                status
                                qtyProvided
                                priceAsked
                                healthProduct{
                                  id
                                  uuid
                                  code
                                  fullCode
                                  label
                                  priceHomologated
                                  productType{
                                    id
                                    label
                                  }
                                }
                                jsonExt
                              }
                            services {
                                id
                                status
                                qtyProvided
                                priceAsked
                                service {
                                    id
                                    code
                                    name
                                    type
                                    categoryType
                                    price

                                }
                                jsonExt
                            }
                            items {
                                id
                                status
                                qtyProvided
                                priceAsked
                                item {
                                    id
                                    code
                                    name
                                    type
                                    price

                                }
                                jsonExt
                            }
                        }
                    }
                }
            }    `,
        fetchPolicy: "network-only",
      });

      if (data) {
        dispatch(GetPreauthDataSuccess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(GetPreauthDataFailure(error.message));
    }
  };
};

export const fetchNotifications = (userID, first = 10) => {
  return async (dispatch) => {
    dispatch(fetchNotificationsRequest());
    try {
      const { data } = await client.query({
        query: gql`query CamuNotifications {
            camuNotifications(first: ${first}, user_Id: "${userID}"){
                totalCount
                edgeCount
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    node {
                        id
                        title
                        module
                        message
                        isRead
                        createdAt
                        redirectUrl
                    }
                }
            }
        }
        `,
        fetchPolicy: "network-only",
      });
      if (data) {
        // dispatch({ type: FETCH_LOCATION_SUCCESS, payload: data });
        dispatch(fetchNotificationsSucess(data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(fetchNotificationsFailure(error.message));
    }
  };
};

function formatNotificationGQL(data) {
  return `
        ${!!data.userId ? `userId: "${data.userId}"` : ""}
        ${!!data.readAll ? `readAll: ${data.readAll}` : ""}
        ${!!data.id ? `notificationId: "${decodeId(data.id)}"` : ""}
    `;
}

export function fetchFosaFacilityUserSpecialties() {
  return async (dispatch) => {
    try {
      const { data } = await client.query({
        query: gql`
      {
        insureeSpecialities {
          totalCount
          edgeCount
          edges {
            cursor
            node {
              id
              uuid
              designation
            }
          }
        }
      }
    `,
      });

      dispatch({
        type: "FETCH_FOSA_FACILITY_USER_SPECIALTIES",
        payload: data,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
}

export function fetchFosaFacilityUserPositions() {
  return async (dispatch) => {
    try {
      const { data } = await client.query({
        query: gql`
      {
        healthFacilityInsureePositions {
          totalCount
          edgeCount
          edges {
            cursor
            node {
              id
              uuid
              designation
              isHealthProfessional
            }
          }
        }
      }
    `,
      });

      dispatch({
        type: "FETCH_FOSA_FACILITY_USER_POSITIONS",
        payload: data,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
}

export const markNotificationAsRead = (payloadData) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      const mutationQuery = `mutation MarkNotificationAsRead {
    markNotificationAsRead(${formatNotificationGQL(payloadData)}) {
        success
    }
   }`;
      const { data } = await client.mutate({
        mutation: gql`
            ${mutationQuery}
        `,
      });
      dispatch(fetchDataSuccess(data));
    } catch (error) {
      console.error("Error creating user:", error);
      dispatch(fetchDataFailure(error.message));
    }
  };
};

const DELETE_CLAIMS_MUTATION = gql`
  mutation DeleteClaims($input: DeleteClaimsMutationInput!) {
    deleteClaims(input: $input) {
      internalId
      clientMutationId
    }
  }
`;

export const deleteClaims = async (claimUuids) => {
  try {
    const { data } = await client.mutate({
      mutation: DELETE_CLAIMS_MUTATION,
      variables: { input: { uuids: claimUuids } },
    });
    console.log("Claims deleted successfully:", data);
    return data;
  } catch (error) {
    console.error("Error deleting claims:", error);
    throw error;
  }
};

export const fetchClaimChat =
  (claimUuid) =>
    async (dispatch, getState, { client }) => {
      dispatch(fetchClaimChatRequest());
      try {
        const { data } = await client.query({
          query: gql`
        query ClaimChats($claimUuid: String!) {
          claimChats(claimUuid: $claimUuid) {
            edges {
              node {
                uuid
                message
                createdDate
                sender {
                  id
                  username
                }
                isRead
              }
            }
          }
        }
      `,
          variables: { claimUuid },
        });

        const messages = data.claimChats.edges.map((edge) => edge.node);
        dispatch(fetchClaimChatSuccess(messages));
      } catch (error) {
        dispatch(fetchClaimChatFailure(error.message));
      }
    };

export const createClaimChat =
  (input) =>
    async (dispatch, getState, { client }) => {
      dispatch(createClaimChatRequest());
      try {
        const { data } = await client.mutate({
          mutation: gql`
        mutation CreateClaimChat($input: CreateClaimChatMutationInput!) {
          createClaimChat(input: $input) {
            clientMutationId
          }
        }
      `,
          variables: {
            input: {
              claimUuid: input.claimUuid,
              message: input.message,
            },
          },
        });

        dispatch(createClaimChatSuccess(data));
        // Refresh chat messages after creating a new one
        // dispatch(fetchClaimChat(input.claimUuid));
      } catch (error) {
        dispatch(createClaimChatFailure(error.message));
      }
    };

export const verifyUserAndUpdatePassword = (params) => {
  return async (dispatch) => {
    dispatch({
      type: "VERIFY_USER_AND_UPDATE_PASSWORD_REQUEST",
    });

    const mutationQuery = `mutation verifyUserAndUpdatePassword {
      verifyUserAndUpdatePassword(userId: "${params.user_id}", token: "${params.token}", password: "${params.password}") {
        success
        message
      }
    }`;

    try {
      const { data } = await client.mutate({
        mutation: gql`${mutationQuery}`,
      });

      if (data?.verifyUserAndUpdatePassword?.success) {
        dispatch({
          type: "VERIFY_USER_AND_UPDATE_PASSWORD_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "VERIFY_USER_AND_UPDATE_PASSWORD_FAILURE",
          payload: data?.verifyUserAndUpdatePassword?.message,
        });
      }
    } catch (error) {
      console.error("Error verifying user and updating password:", error);
      dispatch({
        type: "VERIFY_USER_AND_UPDATE_PASSWORD_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const fetchPolicyHolderInsuree = (params) => {
  return async (dispatch) => {
    dispatch({
      type: "FETCH_PICKER_POLICYHOLDER_INSUREE_REQUEST",
    });
    try {
      const { data } = await client.query({
        query: gql`
          query policyHolderInsuree {
            policyHolderInsuree(${params.join(" ")}) {
                totalCount
                edgeCount
                edges {
                    cursor
                    node {
                        id
                        insuree{
                          id
                          chfId
                          lastName
                          otherNames
                        }
                    }
                }
            }
          }
        `,
      });

      if (data) {
        dispatch({
          type: "FETCH_PICKER_POLICYHOLDER_INSUREE_SUCCESS",
          payload: data?.policyHolderInsuree,
        });
      }
    } catch (error) {
      // Error handling
      dispatch({
        type: "FETCH_PICKER_POLICYHOLDER_INSUREE_FAILURE",
        payload: error.message,
      });
    }
  };
};
